/* eslint-disable */
import { chakra, forwardRef } from "@chakra-ui/react";
import React from "react";
import { IconProps } from "../../../base/components/Icons";

export const LayoutAlignMiddle = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		fill="currentcolor"
		h="6"
		w="6"
		{...props}
		ref={ref}
	>
		<path
			fillRule="evenodd"
			d="M11 7a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1h-2Zm5 4V8a3 3 0 0 0-3-3h-2a3 3 0 0 0-3 3v3H4a1 1 0 1 0 0 2h4v3a3 3 0 0 0 3 3h2a3 3 0 0 0 3-3v-3h4a1 1 0 1 0 0-2h-4Z"
			clipRule="evenodd"
		></path>
	</chakra.svg>
));

export const LayoutAlignLeft = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		fill="currentcolor"
		h="6"
		w="6"
		{...props}
		ref={ref}
	>
		<path
			fillRule="evenodd"
			d="M4 3a1 1 0 0 1 1 1v16a1 1 0 1 1-2 0V4a1 1 0 0 1 1-1Zm6 7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-8ZM7.879 8.879A3 3 0 0 1 10 8h8a3 3 0 0 1 3 3v2a3 3 0 0 1-3 3h-8a3 3 0 0 1-3-3v-2a3 3 0 0 1 .879-2.121Z"
			clipRule="evenodd"
		></path>
	</chakra.svg>
));

export const LayoutAlignRight = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		fill="currentcolor"
		h="6"
		w="6"
		{...props}
		ref={ref}
	>
		<path
			fillRule="evenodd"
			d="M20 3a1 1 0 0 1 1 1v16a1 1 0 1 1-2 0V4a1 1 0 0 1 1-1ZM6 10a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H6ZM3.879 8.879A3 3 0 0 1 6 8h8a3 3 0 0 1 3 3v2a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3v-2a3 3 0 0 1 .879-2.121Z"
			clipRule="evenodd"
		></path>
	</chakra.svg>
));

export const LayoutAlignTop = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		fill="currentcolor"
		h="6"
		w="6"
		{...props}
		ref={ref}
	>
		<path
			fillRule="evenodd"
			d="M3 4a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm8 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1h-2ZM8.879 7.879A3 3 0 0 1 11 7h2a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3h-2a3 3 0 0 1-3-3v-8a3 3 0 0 1 .879-2.121Z"
			clipRule="evenodd"
		></path>
	</chakra.svg>
));

export const LayoutAlignBottom = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		fill="currentcolor"
		h="6"
		w="6"
		{...props}
		ref={ref}
	>
		<path
			fill-rule="evenodd"
			d="M11 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-2ZM8.879 3.879A3 3 0 0 1 11 3h2a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3h-2a3 3 0 0 1-3-3V6a3 3 0 0 1 .879-2.121ZM3 20a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Z"
			clip-rule="evenodd"
		/>
	</chakra.svg>
));

export const LayoutAlignCenter = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		fill="currentcolor"
		h="6"
		w="6"
		{...props}
		ref={ref}
	>
		<path
			fillRule="evenodd"
			d="M12 3a1 1 0 0 1 1 1v4h3a3 3 0 0 1 3 3v2a3 3 0 0 1-3 3h-3v4a1 1 0 1 1-2 0v-4H8a3 3 0 0 1-3-3v-2a3 3 0 0 1 3-3h3V4a1 1 0 0 1 1-1Zm-4 7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H8Z"
			clipRule="evenodd"
		></path>
	</chakra.svg>
));

export const TextAlignLeft = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		fill="currentcolor"
		h="6"
		w="6"
		{...props}
		ref={ref}
	>
		<path
			fillRule="evenodd"
			d="M3 6a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 6a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 6a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Z"
			clipRule="evenodd"
		></path>
	</chakra.svg>
));

export const TextAlignRight = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		fill="currentcolor"
		h="6"
		w="6"
		{...props}
		ref={ref}
	>
		<path
			fillRule="evenodd"
			d="M3 6a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm6 6a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H10a1 1 0 0 1-1-1Zm-4 6a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1Z"
			clipRule="evenodd"
		></path>
	</chakra.svg>
));

export const TextAlignCenter = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		fill="currentcolor"
		h="6"
		w="6"
		{...props}
		ref={ref}
	>
		<path
			xmlns="http://www.w3.org/2000/svg"
			fillRule="evenodd"
			d="M3 6a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm4 6a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1Zm-2 6a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1Z"
			clipRule="evenodd"
		/>
	</chakra.svg>
));

export const TextAlignJustify = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		fill="currentcolor"
		h="6"
		w="6"
		{...props}
		ref={ref}
	>
		<path
			fillRule="evenodd"
			d="M3 6a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 6a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 6a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Z"
			clipRule="evenodd"
		></path>
	</chakra.svg>
));

export const AlignTop = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		{...props}
		ref={ref}
	>
		<path
			xmlns="http://www.w3.org/2000/svg"
			fillRule="evenodd"
			d="M3 4a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm8 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1h-2ZM8.879 7.879A3 3 0 0 1 11 7h2a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3h-2a3 3 0 0 1-3-3v-8a3 3 0 0 1 .879-2.121Z"
			clipRule="evenodd"
		/>
	</chakra.svg>
));

export const AlignMiddle = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		{...props}
		ref={ref}
	>
		<path
			xmlns="http://www.w3.org/2000/svg"
			fillRule="evenodd"
			d="M11 7a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1h-2Zm5 4V8a3 3 0 0 0-3-3h-2a3 3 0 0 0-3 3v3H4a1 1 0 1 0 0 2h4v3a3 3 0 0 0 3 3h2a3 3 0 0 0 3-3v-3h4a1 1 0 1 0 0-2h-4Z"
			clipRule="evenodd"
		/>
	</chakra.svg>
));

export const AlignBottom = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		{...props}
		ref={ref}
	>
		<path
			xmlns="http://www.w3.org/2000/svg"
			fillRule="evenodd"
			d="M11 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-2ZM8.879 3.879A3 3 0 0 1 11 3h2a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3h-2a3 3 0 0 1-3-3V6a3 3 0 0 1 .879-2.121ZM3 20a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Z"
			clipRule="evenodd"
		/>
	</chakra.svg>
));

export const AlignSpaceBetween = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		{...props}
		ref={ref}
	>
		<path
			xmlns="http://www.w3.org/2000/svg"
			fillRule="evenodd"
			d="M4 3a1 1 0 0 1 1 1v16a1 1 0 1 1-2 0V4a1 1 0 0 1 1-1Zm16 0a1 1 0 0 1 1 1v16a1 1 0 1 1-2 0V4a1 1 0 0 1 1-1Zm-9 4a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1h-2ZM8.879 5.879A3 3 0 0 1 11 5h2a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3h-2a3 3 0 0 1-3-3V8a3 3 0 0 1 .879-2.121Z"
			clipRule="evenodd"
		/>
	</chakra.svg>
));

export const AlignSpaceAround = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		fill="currentcolor"
		h="6"
		w="6"
		{...props}
		ref={ref}
	>
		<path d="M4 4H5.5V20H4V4ZM7 10L17 10V14L7 14V10ZM20 4H18.5V20H20V4Z" />
	</chakra.svg>
));

export const AlignCenter = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		{...props}
		ref={ref}
	>
		<path
			xmlns="http://www.w3.org/2000/svg"
			fillRule="evenodd"
			d="M12 3a1 1 0 0 1 1 1v4h3a3 3 0 0 1 3 3v2a3 3 0 0 1-3 3h-3v4a1 1 0 1 1-2 0v-4H8a3 3 0 0 1-3-3v-2a3 3 0 0 1 3-3h3V4a1 1 0 0 1 1-1Zm-4 7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H8Z"
			clipRule="evenodd"
		/>
	</chakra.svg>
));

export const AlignLeft = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		{...props}
		ref={ref}
	>
		<path
			xmlns="http://www.w3.org/2000/svg"
			fillRule="evenodd"
			d="M4 3a1 1 0 0 1 1 1v16a1 1 0 1 1-2 0V4a1 1 0 0 1 1-1Zm6 7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-8ZM7.879 8.879A3 3 0 0 1 10 8h8a3 3 0 0 1 3 3v2a3 3 0 0 1-3 3h-8a3 3 0 0 1-3-3v-2a3 3 0 0 1 .879-2.121Z"
			clipRule="evenodd"
		/>
	</chakra.svg>
));

export const AlignRight = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		{...props}
		ref={ref}
	>
		<path
			xmlns="http://www.w3.org/2000/svg"
			fillRule="evenodd"
			d="M20 3a1 1 0 0 1 1 1v16a1 1 0 1 1-2 0V4a1 1 0 0 1 1-1ZM6 10a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H6ZM3.879 8.879A3 3 0 0 1 6 8h8a3 3 0 0 1 3 3v2a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3v-2a3 3 0 0 1 .879-2.121Z"
			clipRule="evenodd"
		/>
	</chakra.svg>
));

export const Desktop = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		fill="currentcolor"
		h="6"
		w="6"
		{...props}
		ref={ref}
	>
		<path
			fillRule="evenodd"
			d="M4.869 5.669A1.6 1.6 0 0 1 6 5.2h12.8a1.6 1.6 0 0 1 1.6 1.6v8a1.6 1.6 0 0 1-1.6 1.6h-3.2V18h.8a.8.8 0 1 1 0 1.6h-8a.8.8 0 0 1 0-1.6h.8v-1.6H6a1.6 1.6 0 0 1-1.6-1.6v-8a1.6 1.6 0 0 1 .47-1.13ZM10.8 16.4V18H14v-1.6h-3.2ZM6 14.8v-8h12.8v8H6Z"
			clipRule="evenodd"
		></path>
	</chakra.svg>
));

export const Tablet = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		fill="currentcolor"
		h="6"
		w="6"
		{...props}
		ref={ref}
	>
		<path
			fillRule="evenodd"
			d="M6.469 4.869A1.6 1.6 0 0 1 7.6 4.4h9.6A1.6 1.6 0 0 1 18.8 6v12.8a1.6 1.6 0 0 1-1.6 1.6H7.6A1.6 1.6 0 0 1 6 18.8V6a1.6 1.6 0 0 1 .469-1.131ZM17.2 6H7.6v12.8h9.6V6Zm-5.931 9.269a1.6 1.6 0 1 1 2.263 2.263 1.6 1.6 0 0 1-2.263-2.263Z"
			clipRule="evenodd"
		></path>
	</chakra.svg>
));

export const Mobile = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 20 20"
		fill="currentcolor"
		h="6"
		w="6"
		{...props}
		ref={ref}
	>
		<path
			fillRule="evenodd"
			d="M7.333 4.667a.667.667 0 0 0-.666.666v9.334a.667.667 0 0 0 .666.666h5.334a.667.667 0 0 0 .666-.666V5.333a.667.667 0 0 0-.666-.666h-1.334a.667.667 0 0 1-.666.666H9.333a.667.667 0 0 1-.666-.666H7.333ZM5.92 3.919a2 2 0 0 1 1.414-.586h5.334a2 2 0 0 1 2 2v9.334a2 2 0 0 1-2 2H7.333a2 2 0 0 1-2-2V5.333A2 2 0 0 1 5.92 3.92ZM10 12.667c.368 0 .667.298.667.666v.007a.667.667 0 0 1-1.334 0v-.007c0-.368.299-.666.667-.666Z"
			clipRule="evenodd"
		></path>
	</chakra.svg>
));

export const Solid = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 28 5"
		{...props}
	>
		<path fill="currentColor" d="M26 3H2V2h24v1Z" />
	</chakra.svg>
));

export const Dotted = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 28 5"
		{...props}
	>
		<path
			fill="currentColor"
			d="M2.5 3H2V2h.5v1Zm2 0h-1V2h1v1Zm2 0h-1V2h1v1Zm2 0h-1V2h1v1Zm2 0h-1V2h1v1Zm2 0h-1V2h1v1Zm2 0h-1V2h1v1Zm2 0h-1V2h1v1Zm2 0h-1V2h1v1Zm2 0h-1V2h1v1Zm2 0h-1V2h1v1Zm2 0h-1V2h1v1ZM26 3h-.5V2h.5v1Z"
		/>
	</chakra.svg>
));

export const Dash = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 28 5"
		{...props}
	>
		<path
			fill="currentColor"
			d="M3 3H2V2h1v1Zm4 0H5V2h2v1Zm4 0H9V2h2v1Zm4 0h-2V2h2v1Zm4 0h-2V2h2v1Zm4 0h-2V2h2v1Zm3 0h-1V2h1v1Z"
		/>
	</chakra.svg>
));

export const Double = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 28 5"
		{...props}
	>
		<path fill="currentColor" d="M2 2h24V1H2v1Zm0 2h24V3H2v1Z" />
	</chakra.svg>
));

export const Groove = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 28 5"
		{...props}
	>
		<path fill="currentColor" fillRule="evenodd" d="M26 2.5H2v-1h24v1Z" />
		<path
			fill="currentColor"
			fillOpacity=".70"
			fillRule="evenodd"
			d="M26 3.5H2v-1h24v1Z"
			opacity=".7"
		/>
	</chakra.svg>
));

export const None = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 28 5"
		{...props}
	>
		<path
			fill="currentColor"
			// eslint-disable-next-line
			d="M12.297 5c-.697 0-1.256-.226-1.676-.678-.419-.452-.628-1.04-.628-1.765 0-.778.214-1.399.641-1.862C11.062.232 11.642 0 12.375 0c.68 0 1.226.225 1.64.675.416.45.624 1.038.624 1.764 0 .79-.213 1.414-.638 1.873-.425.459-.993.688-1.704.688Zm.038-4.295a1.35 1.35 0 0 0-1.083.496c-.277.33-.415.766-.415 1.306 0 .537.135.97.405 1.299.27.328.622.492 1.059.492.463 0 .829-.156 1.096-.469.268-.312.402-.75.402-1.312 0-.578-.13-1.025-.391-1.34-.26-.314-.617-.472-1.073-.472Zm6.417 4.214h.877V.081h-.773v3.117c0 .306.012.523.034.652h-.013a3.67 3.67 0 0 0-.183-.297L16.461.08h-.935v4.838h.776v-3.17c0-.34-.009-.562-.027-.665h.02c.039.097.087.19.146.28l2.31 3.556Zm2.078 0h2.716v-.678h-1.913V2.81h1.663v-.679h-1.663V.762h1.805v-.68H20.83V4.92Zm-12.605 0h.878V.081H8.33v3.117c0 .306.011.523.034.652H8.35a3.647 3.647 0 0 0-.182-.297L5.935.08H5v4.838h.776v-3.17c0-.34-.009-.562-.027-.665h.02c.038.097.087.19.145.28l2.311 3.556Z"
		/>
	</chakra.svg>
));

export const Copy = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 28 5"
		{...props}
	>
		<path
			xmlns="http://www.w3.org/2000/svg"
			fillRule="evenodd"
			d="M14 5.5a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1h8Zm-7 12H6a3 3 0 0 1-3-3v-8a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v1h1a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3h-8a3 3 0 0 1-3-3v-1Zm2 0h5a3 3 0 0 0 3-3v-5h1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1v-1Z"
			clipRule="evenodd"
		/>
	</chakra.svg>
));

export const Global = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 28 5"
		{...props}
	>
		<path
			xmlns="http://www.w3.org/2000/svg"
			fillRule="evenodd"
			d="M8.173 3.261a10 10 0 1 1 7.654 18.478A10 10 0 0 1 8.173 3.261ZM10 4.754v3.518h4V4.754a8 8 0 0 0-4 0Zm-2 .818v2.7H5.208A8 8 0 0 1 8 5.572Zm0 4.7H4.316a8 8 0 0 0-.117 4H8v-4Zm0 6H4.945A8.003 8.003 0 0 0 8 19.428v-3.155Zm2 0h4v3.974a8 8 0 0 1-4 0v-3.973Zm4-2h-4v-4h4v4Zm2 2v3.156a8.001 8.001 0 0 0 3.055-3.155H16Zm3.801-2H16v-4h3.684a7.998 7.998 0 0 1 .117 4Zm-2.144-7.429a8 8 0 0 1 1.135 1.43H16V5.571a8.001 8.001 0 0 1 1.657 1.271Z"
			clipRule="evenodd"
		/>
	</chakra.svg>
));

export const Image = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		w="24px"
		h="24px"
		{...props}
	>
		<path
			xmlns="http://www.w3.org/2000/svg"
			fillRule="evenodd"
			// eslint-disable-next-line
			d="M6 4a2 2 0 0 0-2 2v7.586l3.293-3.293.014-.014c.614-.59 1.37-.949 2.193-.949s1.58.358 2.193.95l.014.013L14 12.586l.293-.293.014-.014c.614-.59 1.37-.949 2.193-.949s1.58.358 2.193.95l.014.013L20 13.586V6a2 2 0 0 0-2-2H6Zm16 11.999V6a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v12a4 4 0 0 0 4 4h12a4 4 0 0 0 4-4v-2.001Zm-2 .415-2.7-2.7c-.311-.297-.588-.384-.8-.384-.212 0-.489.087-.8.385l-.286.285 1.293 1.293a1 1 0 0 1-1.414 1.414L10.3 11.715c-.311-.298-.588-.385-.8-.385-.212 0-.489.087-.8.385l-4.7 4.7V18a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-1.586ZM14 8a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H15a1 1 0 0 1-1-1Z"
			clipRule="evenodd"
		/>
	</chakra.svg>
));

export const Lock = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 28 5"
		{...props}
	>
		<path
			fillRule="evenodd"
			d="M5 11.6A1.4 1.4 0 0 0 3.6 13v7A1.4 1.4 0 0 0 5 21.4h14a1.4 1.4 0 0 0 1.4-1.4v-7a1.4 1.4 0 0 0-1.4-1.4H5ZM2.4 13A2.6 2.6 0 0 1 5 10.4h14a2.6 2.6 0 0 1 2.6 2.6v7a2.6 2.6 0 0 1-2.6 2.6H5A2.6 2.6 0 0 1 2.4 20v-7Z"
			clipRule="evenodd"
		/>
		<path
			fillRule="evenodd"
			d="M12 2.6A4.4 4.4 0 0 0 7.6 7v4a.6.6 0 1 1-1.2 0V7a5.6 5.6 0 1 1 11.2 0v4a.6.6 0 1 1-1.2 0V7A4.4 4.4 0 0 0 12 2.6Z"
			clipRule="evenodd"
		/>
	</chakra.svg>
));

export const Unlock = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 20 20"
		{...props}
	>
		<path
			fillRule="evenodd"
			d="M5 11.6A1.4 1.4 0 0 0 3.6 13v7A1.4 1.4 0 0 0 5 21.4h14a1.4 1.4 0 0 0 1.4-1.4v-7a1.4 1.4 0 0 0-1.4-1.4H5ZM2.4 13A2.6 2.6 0 0 1 5 10.4h14a2.6 2.6 0 0 1 2.6 2.6v7a2.6 2.6 0 0 1-2.6 2.6H5A2.6 2.6 0 0 1 2.4 20v-7Z"
			clipRule="evenodd"
		/>
		<path
			fillRule="evenodd"
			d="M12 2.6A4.4 4.4 0 0 0 7.6 7v4a.6.6 0 1 1-1.2 0V7a5.6 5.6 0 1 1 11.2 0 .6.6 0 1 1-1.2 0A4.4 4.4 0 0 0 12 2.6Z"
			clipRule="evenodd"
		/>
	</chakra.svg>
));

export const Pencil = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		{...props}
	>
		<path
			xmlns="http://www.w3.org/2000/svg"
			fillRule="evenodd"
			d="M13.793 5.293a3.828 3.828 0 1 1 5.414 5.414l-.998.999-.002.001-.001.002-9.499 9.498A1 1 0 0 1 8 21.5H4a1 1 0 0 1-1-1v-4a1 1 0 0 1 .293-.707l10.5-10.5ZM13.5 8.414l-8.5 8.5V19.5h2.586l8.5-8.5L13.5 8.414Zm4 1.172L14.914 7l.293-.293a1.829 1.829 0 0 1 2.586 2.586l-.293.293Z"
			clipRule="evenodd"
		/>
	</chakra.svg>
));

export const Plus = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 28 5"
		{...props}
	>
		<path
			xmlns="http://www.w3.org/2000/svg"
			d="M12 22.45c-.6 0-1-.4-1-1v-8H3.1c-.6 0-1-.4-1-1s.4-1 1-1H11v-7.9c0-.6.4-1 1-1s1 .4 1 1v7.9h7.9c.6 0 1 .4 1 1s-.4 1-1 1H13v8c0 .6-.4 1-1 1Z"
		/>
	</chakra.svg>
));

export const SquarePlay = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 28 5"
		{...props}
	>
		<path
			xmlns="http://www.w3.org/2000/svg"
			fillRule="evenodd"
			d="M4 5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5Zm1-3a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3H5Zm4.555 5.168A1 1 0 0 0 8 8v8a1 1 0 0 0 1.555.832l6-4a1 1 0 0 0 0-1.664l-6-4ZM13.197 12 10 14.132V9.869L13.197 12Z"
			clipRule="evenodd"
		/>
	</chakra.svg>
));

export const Layer = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 28 5"
		{...props}
	>
		<path
			xmlns="http://www.w3.org/2000/svg"
			fillRule="evenodd"
			d="M11.553 3.606a1 1 0 0 1 .894 0l8 4a1 1 0 0 1 0 1.788l-8 4a1 1 0 0 1-.894 0l-8-4a1 1 0 0 1 0-1.788l8-4ZM6.236 8.5 12 11.382 17.764 8.5 12 5.618 6.236 8.5Zm-3.13 3.553a1 1 0 0 1 1.341-.447L12 15.382l7.553-3.776a1 1 0 1 1 .894 1.788l-8 4a1 1 0 0 1-.894 0l-8-4a1 1 0 0 1-.447-1.341Zm0 4a1 1 0 0 1 1.341-.447L12 19.382l7.553-3.776a1 1 0 1 1 .894 1.788l-8 4a1 1 0 0 1-.894 0l-8-4a1 1 0 0 1-.447-1.341Z"
			clipRule="evenodd"
		/>
	</chakra.svg>
));

export const Advanced = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		fill="none"
		{...props}
	>
		<path
			xmlns="http://www.w3.org/2000/svg"
			stroke="currentcolor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="2"
			// eslint-disable-next-line
			d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 0 0-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 0 0-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.723 1.723 0 0 0-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 0 0-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 0 0 1.066-2.573c-.94-1.543.826-3.31 2.37-2.37 1 .608 2.296.07 2.572-1.065Z"
		/>
		<path
			stroke="currentcolor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="2"
			d="M9 12a3 3 0 1 0 6 0 3 3 0 0 0-6 0Z"
		></path>
	</chakra.svg>
));

export const General = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		fill="currentcolor"
		{...props}
	>
		<path
			xmlns="http://www.w3.org/2000/svg"
			fillRule="evenodd"
			d="M5 4a1 1 0 0 0-1 1v4h5V4H5Zm0-2a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3H5Zm6 2v5h9V5a1 1 0 0 0-1-1h-8Zm9 7h-9v9h8a1 1 0 0 0 1-1v-8ZM9 20v-9H4v8a1 1 0 0 0 1 1h4Z"
			clipRule="evenodd"
		/>
	</chakra.svg>
));

export const Style = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		fill="currentcolor"
		{...props}
	>
		<path
			xmlns="http://www.w3.org/2000/svg"
			fillRule="evenodd"
			d="M8.173 2.761a10 10 0 1 1 7.654 18.478A10 10 0 0 1 8.173 2.761ZM11 4.063a8 8 0 0 0 0 15.874V4.063Zm2 0v2.523l2.001-2.002A8 8 0 0 0 13 4.063Zm3.808 1.543L13 9.414v2.172l4.942-4.942a8.077 8.077 0 0 0-1.134-1.038ZM19.1 8.314l-6.1 6.1v2.172l6.712-6.712a8 8 0 0 0-.612-1.56Zm.889 4.111L13 19.416v.522a7.999 7.999 0 0 0 6.989-7.512Z"
			clipRule="evenodd"
		/>
	</chakra.svg>
));

export const Close = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		{...props}
	>
		<path
			xmlns="http://www.w3.org/2000/svg"
			d="m13.4 12.5 8.3-8.3c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0L12 11.1 3.7 2.8c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l8.3 8.3-8.3 8.3c-.4.4-.4 1 0 1.4.2.2.4.3.7.3.3 0 .5-.1.7-.3l8.3-8.3 8.3 8.3c.2.2.5.3.7.3.2 0 .5-.1.7-.3.4-.4.4-1 0-1.4l-8.3-8.3Z"
		/>
	</chakra.svg>
));

export const HeadingLayout1Style1 = forwardRef<IconProps, "svg">(
	(props, ref) => (
		<chakra.svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 240 104"
			{...props}
		>
			{/* eslint-disable-next-line max-len */}
			<path
				fill="#BDBDBD"
				d="M87.16 63.358H84V40h3.16v23.358Zm15.168-18.125h-2.162v5.245h-5.624v-5.245h-2.187v12.64h2.186v-5.638h5.625v5.587h2.174l-.012-12.59Zm8.607 12.298a3.799 3.799 0 0 0 1.492-1.264l-1.125-1.087a2.851 2.851 0 0 1-2.351 1.176 2.313 2.313 0 0 1-1.707-.683 2.784 2.784 0 0 1-.771-1.833h6.105v-.846a5.12 5.12 0 0 0-1.036-3.438 3.66 3.66 0 0 0-2.958-1.264 3.934 3.934 0 0 0-2.174.619 4.075 4.075 0 0 0-1.517 1.706 5.762 5.762 0 0 0-.543 2.528v.266a4.6 4.6 0 0 0 1.264 3.35 4.366 4.366 0 0 0 3.236 1.263 4.792 4.792 0 0 0 2.098-.493h-.013Zm-.986-7.015a2.6 2.6 0 0 1 .594 1.593v.164h-4.032a3.2 3.2 0 0 1 .683-1.694 1.797 1.797 0 0 1 1.403-.594 1.774 1.774 0 0 1 1.365.531h-.013Zm11.97 7.306v-.152a4.953 4.953 0 0 1-.354-2.01v-4.22a2.921 2.921 0 0 0-.91-2.313 3.869 3.869 0 0 0-2.616-.834 4.871 4.871 0 0 0-1.959.379 3.465 3.465 0 0 0-1.391 1.049c-.324.41-.502.918-.505 1.44h2.098a1.114 1.114 0 0 1 .455-.91c.341-.245.755-.37 1.175-.353a1.607 1.607 0 0 1 1.264.43c.278.322.423.738.405 1.163v.619h-1.264a5.398 5.398 0 0 0-3.173.796 2.667 2.667 0 0 0-1.112 2.288 2.595 2.595 0 0 0 .897 1.997 3.554 3.554 0 0 0 4.753-.24c.041.3.122.593.24.872h1.997Zm-5.523-1.87a1.26 1.26 0 0 1-.405-.974 1.341 1.341 0 0 1 .594-1.15 3.134 3.134 0 0 1 1.757-.405h1.125v1.77a1.944 1.944 0 0 1-.822.809c-.359.2-.764.304-1.175.303a1.578 1.578 0 0 1-1.049-.354h-.025Zm8 .72a3.19 3.19 0 0 0 2.655 1.264 3.107 3.107 0 0 0 2.528-1.138l.101.973h1.896v-13.22h-2.073v4.777a3.057 3.057 0 0 0-2.402-1.036 3.219 3.219 0 0 0-2.692 1.264 5.616 5.616 0 0 0-.998 3.463 5.751 5.751 0 0 0 1.036 3.653h-.051Zm1.631-5.852a1.816 1.816 0 0 1 1.58-.81 1.945 1.945 0 0 1 1.858 1.126v3.994a1.974 1.974 0 0 1-1.883 1.15 1.783 1.783 0 0 1-1.555-.796 3.88 3.88 0 0 1-.531-2.238 4.375 4.375 0 0 1 .556-2.426h-.025Zm8.039-3.995a1.152 1.152 0 0 0 .885.316 1.136 1.136 0 0 0 .872-.316 1.021 1.021 0 0 0 .316-.783 1.089 1.089 0 0 0-.316-.809 1.135 1.135 0 0 0-.872-.316 1.163 1.163 0 0 0-.885.316 1.115 1.115 0 0 0-.304.809 1.057 1.057 0 0 0 .329.783h-.025Zm1.921 1.644h-2.073v9.353h2.098l-.025-9.353Zm2.263 0v9.353h2.123V51.16a2.042 2.042 0 0 1 1.896-1.15 1.646 1.646 0 0 1 1.264.43c.27.364.404.81.379 1.263v6.067h2.098v-6.13c0-2.237-1.024-3.35-2.97-3.35a3.36 3.36 0 0 0-2.718 1.265V48.48l-2.072-.012Zm10.541 8.215a3.273 3.273 0 0 0 2.68 1.264 3.068 3.068 0 0 0 2.426-1.01v.631a2.166 2.166 0 0 1-.606 1.669 2.327 2.327 0 0 1-1.656.568 3.027 3.027 0 0 1-2.376-1.15l-.999 1.264c.388.501.903.89 1.492 1.125a5.127 5.127 0 0 0 2.009.43 4.347 4.347 0 0 0 3.084-1.062 3.78 3.78 0 0 0 1.151-2.907v-9.037H154.1l-.089.935a3.127 3.127 0 0 0-2.528-1.112 3.298 3.298 0 0 0-2.717 1.264 5.475 5.475 0 0 0-1.024 3.476 5.651 5.651 0 0 0 1.074 3.652h-.025Zm1.631-5.852a1.837 1.837 0 0 1 1.605-.821 2.01 2.01 0 0 1 1.87 1.061v4.12a2.036 2.036 0 0 1-1.883 1.088 1.829 1.829 0 0 1-1.592-.809 3.702 3.702 0 0 1-.557-2.225 4.173 4.173 0 0 1 .582-2.414h-.025Z"
			></path>
		</chakra.svg>
	)
);

export const HeadingLayout1Style2 = forwardRef<IconProps, "svg">(
	(props, ref) => (
		<chakra.svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 240 104"
			{...props}
		>
			{/* eslint-disable-next-line max-len */}
			<path d="M97.008 56.544h-2.1v-5.467h-5.933v5.467h-2.092V43.94h2.092v5.3h5.932v-5.3h2.1v12.604Zm10.503-3.946h-6.135c.023.832.278 1.473.765 1.925.492.45 1.166.676 2.021.676a4.45 4.45 0 0 0 2.646-.861v1.643c-.821.516-1.905.774-3.252.774-1.325 0-2.365-.407-3.12-1.222-.75-.82-1.126-1.971-1.126-3.454 0-1.4.414-2.54 1.24-3.419.832-.885 1.863-1.327 3.094-1.327 1.23 0 2.182.395 2.856 1.187.674.79 1.011 1.89 1.011 3.295v.783Zm-1.969-1.442c-.006-.732-.179-1.3-.519-1.705-.339-.41-.808-.615-1.406-.615-.586 0-1.084.214-1.494.642-.404.427-.653.987-.747 1.678h4.166Zm10.819 5.388h-1.977v-1.406h-.035c-.621 1.078-1.533 1.617-2.734 1.617-.885 0-1.579-.24-2.083-.72-.498-.481-.747-1.117-.747-1.908 0-1.7.979-2.69 2.936-2.97l2.672-.379c0-1.283-.61-1.925-1.829-1.925-1.072 0-2.039.37-2.9 1.108v-1.784c.949-.563 2.045-.844 3.287-.844 2.274 0 3.41 1.12 3.41 3.357v5.854Zm-1.968-4.421-1.89.264c-.586.076-1.028.22-1.327.43-.293.206-.44.569-.44 1.09 0 .381.135.695.405.94.275.24.641.361 1.098.361.621 0 1.134-.217 1.538-.65.411-.44.616-.99.616-1.653v-.782Zm12.647 4.421h-2.039v-1.53h-.035c-.656 1.16-1.667 1.74-3.032 1.74-1.108 0-1.996-.4-2.663-1.203-.663-.809-.994-1.907-.994-3.296 0-1.488.367-2.68 1.099-3.577.738-.897 1.72-1.345 2.944-1.345 1.213 0 2.095.486 2.646 1.459h.035V43.22h2.039v13.324Zm-2.013-4.113v-1.178c0-.639-.208-1.18-.624-1.626-.416-.445-.946-.668-1.591-.668-.761 0-1.362.284-1.801.852-.434.569-.651 1.357-.651 2.365 0 .914.208 1.637.624 2.17.422.528.988.792 1.697.792.697 0 1.262-.255 1.696-.765.434-.516.65-1.163.65-1.942Zm5.704-6.777a1.24 1.24 0 0 1-.861-.325 1.077 1.077 0 0 1-.351-.826c0-.334.117-.612.351-.835a1.22 1.22 0 0 1 .861-.334c.346 0 .639.111.879.334.241.223.361.5.361.835 0 .316-.12.589-.361.817-.24.223-.533.334-.879.334Zm1.011 10.89h-2.039v-9h2.039v9Zm10.688 0h-2.039v-5.071c0-1.682-.595-2.523-1.785-2.523-.621 0-1.133.235-1.538.703-.404.463-.606 1.05-.606 1.758v5.133h-2.048v-9h2.048v1.494h.035c.674-1.137 1.647-1.705 2.918-1.705.979 0 1.726.32 2.241.958.516.633.774 1.55.774 2.751v5.502Zm10.687-.721c0 3.305-1.661 4.957-4.983 4.957-1.172 0-2.195-.196-3.068-.589v-1.863c.985.563 1.919.844 2.804.844 2.139 0 3.208-1.052 3.208-3.155v-.985h-.035c-.674 1.149-1.688 1.723-3.041 1.723-1.096 0-1.981-.399-2.654-1.195-.668-.803-1.002-1.878-1.002-3.226 0-1.53.36-2.745 1.081-3.648.72-.902 1.711-1.353 2.97-1.353 1.19 0 2.072.486 2.646 1.459h.035v-1.248h2.039v8.28Zm-2.021-3.401v-1.17c0-.632-.211-1.17-.633-1.616a2.04 2.04 0 0 0-1.565-.677c-.773 0-1.379.287-1.819.861-.433.569-.65 1.365-.65 2.39 0 .886.208 1.595.624 2.128.422.527.978.79 1.67.79.703 0 1.274-.251 1.714-.755.439-.51.659-1.16.659-1.951Z" />
		</chakra.svg>
	)
);

export const HeadingLayout2Style1 = forwardRef<IconProps, "svg">(
	(props, ref) => (
		<chakra.svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 240 104"
			{...props}
		>
			{/* eslint-disable-next-line max-len */}
			<path
				fill="#BDBDBD"
				d="M169.968 60.767H70.032v2.875h99.936v-2.875Zm-39.023 0H70.032V40.642h60.913v20.125ZM84.718 45.434H83.09v3.833h-4.225v-3.833h-1.637v9.305h1.637v-4.082h4.225v4.13h1.628v-9.353Zm6.453 9.094a2.775 2.775 0 0 0 1.123-.958l-.847-.757a2.136 2.136 0 0 1-1.76.862 1.72 1.72 0 0 1-1.276-.498 2.058 2.058 0 0 1-.58-1.351h4.568v-.642a3.755 3.755 0 0 0-.78-2.55 2.778 2.778 0 0 0-2.218-.9 3.058 3.058 0 0 0-1.628.45c-.47.321-.846.765-1.085 1.284a4.154 4.154 0 0 0-.4 1.85v.192a3.23 3.23 0 0 0 .922 2.46 3.187 3.187 0 0 0 2.438.942c.526 0 1.045-.115 1.523-.336v-.048Zm-.743-5.184c.27.333.422.748.429 1.178v.116h-3.008c.043-.458.223-.892.514-1.246a1.34 1.34 0 0 1 1.047-.45 1.287 1.287 0 0 1 1.019.45v-.048Zm9.004 5.395v-.105a3.47 3.47 0 0 1-.266-1.495v-3.067a2.19 2.19 0 0 0-.752-1.715 2.956 2.956 0 0 0-1.97-.614c-.502-.005-1 .09-1.466.278a2.628 2.628 0 0 0-1.037.776 1.71 1.71 0 0 0-.381 1.064h1.57a.829.829 0 0 1 .343-.67 1.43 1.43 0 0 1 .885-.269 1.23 1.23 0 0 1 .952.326 1.178 1.178 0 0 1 .304.862v.45h-.951a4.061 4.061 0 0 0-2.38.595 1.913 1.913 0 0 0-.837 1.696 1.87 1.87 0 0 0 .666 1.467 2.464 2.464 0 0 0 1.723.594 2.489 2.489 0 0 0 1.846-.767c.03.222.09.438.18.642l1.571-.048Zm-4.178-1.332a.958.958 0 0 1-.305-.719.963.963 0 0 1 .448-.843 2.33 2.33 0 0 1 1.313-.307h.847v1.304a1.509 1.509 0 0 1-.618.603c-.27.144-.57.22-.876.22a1.203 1.203 0 0 1-.809-.258Zm5.996.527a2.43 2.43 0 0 0 1.999.959 2.33 2.33 0 0 0 1.903-.844l.077.719h1.446v-9.794h-1.589v3.536a2.318 2.318 0 0 0-1.799-.767 2.422 2.422 0 0 0-2.018.959 4.133 4.133 0 0 0-.752 2.568c-.052.95.216 1.888.762 2.664h-.029Zm1.228-4.322a1.363 1.363 0 0 1 1.18-.594 1.458 1.458 0 0 1 1.399.824v2.961a1.49 1.49 0 0 1-1.408.844 1.334 1.334 0 0 1-1.143-.547 2.897 2.897 0 0 1-.409-1.648 3.193 3.193 0 0 1 .409-1.84h-.028Zm6.101-2.952a.88.88 0 0 0 .656.23.948.948 0 0 0 .667-.23.877.877 0 0 0 0-1.178.89.89 0 0 0-.667-.24.848.848 0 0 0-.656.24.873.873 0 0 0 0 1.178Zm1.437 1.208h-1.609v6.92h1.571l.038-6.92Zm1.694 0v6.92h1.58V49.86a1.507 1.507 0 0 1 1.418-.843 1.211 1.211 0 0 1 .952.316c.208.274.309.615.285.958v4.476h1.58v-4.543c0-1.648-.771-2.472-2.236-2.472a2.511 2.511 0 0 0-2.037.958v-.805l-1.542-.038Zm7.919 6.085a2.468 2.468 0 0 0 2.008.959 2.348 2.348 0 0 0 1.818-.748v.47a1.58 1.58 0 0 1-.457 1.226c-.341.299-.786.45-1.237.422a2.233 2.233 0 0 1-1.79-.853l-.751.959c.296.368.684.652 1.123.824a3.78 3.78 0 0 0 1.503.316 3.28 3.28 0 0 0 2.323-.786 2.768 2.768 0 0 0 .856-2.147v-6.708h-1.456l-.076.7a2.335 2.335 0 0 0-1.904-.825 2.49 2.49 0 0 0-2.036.959 4.011 4.011 0 0 0-.771 2.578c-.044.952.242 1.89.809 2.654h.038Zm1.218-4.331a1.39 1.39 0 0 1 1.199-.604 1.504 1.504 0 0 1 1.409.786v3.038a1.525 1.525 0 0 1-1.418.805 1.376 1.376 0 0 1-1.228-.547 2.72 2.72 0 0 1-.438-1.638 3.04 3.04 0 0 1 .438-1.84h.038Z"
			></path>
		</chakra.svg>
	)
);

export const HeadingLayout3Style1 = forwardRef<IconProps, "svg">(
	(props, ref) => (
		<chakra.svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 240 104"
			{...props}
		>
			{/* eslint-disable-next-line max-len */}
			<path d="M60.79 52v-8h1.448v3.387h3.707V44h1.453v8h-1.453v-3.398h-3.707V52H60.79Zm10.778.117c-.601 0-1.12-.125-1.558-.375a2.54 2.54 0 0 1-1.004-1.07c-.234-.464-.352-1.01-.352-1.637 0-.617.118-1.159.352-1.625.237-.469.568-.833.992-1.094.424-.263.923-.394 1.496-.394.37 0 .719.06 1.047.18.33.117.622.299.875.546.255.248.456.563.602.946.145.38.218.833.218 1.36v.433h-4.918v-.953h3.563a1.521 1.521 0 0 0-.176-.723 1.279 1.279 0 0 0-.48-.504 1.35 1.35 0 0 0-.711-.184c-.29 0-.543.07-.762.211-.219.138-.39.32-.512.547-.12.224-.18.47-.183.739v.832c0 .349.063.648.191.898.128.247.306.438.535.57.23.13.498.196.805.196.206 0 .392-.029.559-.086a1.24 1.24 0 0 0 .433-.262 1.09 1.09 0 0 0 .277-.426l1.32.149a2.058 2.058 0 0 1-.476.914 2.324 2.324 0 0 1-.89.601 3.41 3.41 0 0 1-1.243.211Zm5.591.004c-.38 0-.723-.068-1.027-.203a1.678 1.678 0 0 1-.719-.61c-.174-.268-.262-.598-.262-.992 0-.338.063-.618.188-.84a1.45 1.45 0 0 1 .512-.53 2.58 2.58 0 0 1 .73-.301c.273-.07.556-.122.848-.153.351-.036.636-.069.855-.097.219-.032.378-.079.477-.141.101-.065.152-.165.152-.3v-.024c0-.295-.087-.522-.262-.684-.174-.161-.425-.242-.754-.242-.346 0-.62.075-.824.227-.2.15-.336.329-.406.535l-1.32-.188a2.11 2.11 0 0 1 .515-.914c.24-.247.533-.432.88-.555a3.355 3.355 0 0 1 1.148-.187c.289 0 .576.034.863.101.286.068.548.18.785.336.237.154.427.364.57.63.146.265.22.597.22.995V52h-1.36v-.824h-.047a1.725 1.725 0 0 1-.363.468c-.154.144-.348.26-.582.348a2.347 2.347 0 0 1-.817.13Zm.367-1.039c.284 0 .53-.056.739-.168.208-.114.368-.266.48-.453.115-.188.172-.392.172-.613v-.707a.665.665 0 0 1-.227.101 3.205 3.205 0 0 1-.351.082c-.13.024-.26.044-.387.063a88.48 88.48 0 0 1-.332.047c-.21.028-.4.075-.566.14a.94.94 0 0 0-.395.274.668.668 0 0 0-.144.445c0 .26.095.457.285.59.19.133.432.199.726.199Zm6.45 1.023a2.27 2.27 0 0 1-1.266-.363c-.372-.242-.667-.594-.883-1.054-.216-.461-.324-1.021-.324-1.68 0-.667.11-1.23.328-1.688.221-.46.52-.808.895-1.043a2.3 2.3 0 0 1 1.254-.355c.351 0 .64.06.867.18.226.117.406.259.539.425a2.6 2.6 0 0 1 .308.465h.059V44h1.418v8h-1.39v-.945h-.087a2.41 2.41 0 0 1-.316.465c-.138.161-.32.299-.547.414-.227.114-.512.172-.855.172Zm.394-1.16c.3 0 .555-.08.766-.242.21-.164.37-.392.48-.684.11-.291.164-.631.164-1.019 0-.388-.054-.725-.164-1.012a1.44 1.44 0 0 0-.476-.668 1.232 1.232 0 0 0-.77-.238c-.315 0-.578.082-.789.246a1.49 1.49 0 0 0-.477.68 2.87 2.87 0 0 0-.16.992c0 .375.054.71.16 1.004.11.292.27.522.481.691.214.167.475.25.785.25ZM88.678 52v-6h1.414v6h-1.414Zm.71-6.852a.825.825 0 0 1-.578-.222.718.718 0 0 1-.242-.543.71.71 0 0 1 .243-.543.817.817 0 0 1 .578-.227.81.81 0 0 1 .578.227.71.71 0 0 1 .242.543c0 .21-.08.392-.242.543a.816.816 0 0 1-.578.222Zm3.572 3.336V52h-1.414v-6h1.351v1.02h.07c.139-.336.359-.603.66-.801.306-.198.682-.297 1.13-.297.414 0 .775.088 1.082.266.31.177.55.433.719.769.171.336.256.743.253 1.223V52h-1.414v-3.602c0-.4-.104-.714-.312-.941-.206-.227-.49-.34-.855-.34-.248 0-.468.055-.66.164-.19.107-.34.262-.45.465a1.57 1.57 0 0 0-.16.738Zm7.898 5.891c-.507 0-.944-.069-1.308-.207a2.323 2.323 0 0 1-.88-.547 1.893 1.893 0 0 1-.46-.762l1.273-.308c.058.117.141.233.25.347.11.118.257.214.442.29.187.078.423.117.707.117.401 0 .733-.098.996-.293.263-.193.394-.51.394-.953v-1.137h-.07a2.03 2.03 0 0 1-.32.45 1.642 1.642 0 0 1-.551.386c-.227.104-.512.156-.855.156-.461 0-.88-.108-1.254-.324-.373-.219-.67-.544-.89-.977-.22-.435-.33-.979-.33-1.633 0-.658.11-1.214.33-1.667.22-.456.519-.801.894-1.036a2.3 2.3 0 0 1 1.253-.355c.352 0 .641.06.868.18.229.117.411.259.547.425.135.164.238.32.308.465h.078V46h1.395v6.098c0 .513-.123.937-.367 1.273a2.21 2.21 0 0 1-1.004.754c-.425.167-.907.25-1.446.25Zm.012-3.57c.3 0 .555-.073.766-.22a1.34 1.34 0 0 0 .48-.628c.11-.273.164-.602.164-.984 0-.378-.054-.709-.164-.992a1.417 1.417 0 0 0-.476-.66 1.234 1.234 0 0 0-.77-.239c-.315 0-.578.082-.789.246-.21.164-.37.39-.477.676-.106.284-.16.607-.16.969 0 .367.054.688.16.965.11.273.27.486.481.64.214.151.475.227.785.227Z" />
			<path d="M60 61h120v3H60z" opacity=".1" />
			<path d="M60 61h24v3H60z" />
		</chakra.svg>
	)
);

export const HeadingLayout4Style1 = forwardRef<IconProps, "svg">(
	(props, ref) => (
		<chakra.svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 240 104"
			{...props}
		>
			{/* eslint-disable-next-line max-len */}
			<path d="M87 49.544a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm15.681 7h-2.101v-5.467h-5.933v5.467h-2.091V43.94h2.091v5.3h5.933v-5.3h2.101v12.604Zm10.503-3.946h-6.135c.023.832.278 1.473.764 1.925.493.45 1.166.676 2.022.676.961 0 1.843-.287 2.645-.861v1.643c-.82.516-1.904.774-3.251.774-1.325 0-2.365-.407-3.121-1.222-.75-.82-1.125-1.971-1.125-3.454 0-1.4.413-2.54 1.24-3.419.832-.885 1.863-1.327 3.093-1.327 1.231 0 2.183.395 2.857 1.187.674.79 1.011 1.89 1.011 3.295v.783Zm-1.969-1.442c-.006-.732-.179-1.3-.519-1.705-.34-.41-.808-.615-1.406-.615-.586 0-1.084.214-1.494.642-.404.427-.653.987-.747 1.678h4.166Zm10.819 5.388h-1.977v-1.406h-.036c-.621 1.078-1.532 1.617-2.733 1.617-.885 0-1.579-.24-2.083-.72-.498-.481-.747-1.117-.747-1.908 0-1.7.979-2.69 2.936-2.97l2.671-.379c0-1.283-.609-1.925-1.828-1.925-1.072 0-2.039.37-2.9 1.108v-1.784c.949-.563 2.045-.844 3.287-.844 2.273 0 3.41 1.12 3.41 3.357v5.854Zm-1.969-4.421-1.889.264c-.586.076-1.029.22-1.327.43-.293.206-.44.569-.44 1.09 0 .381.135.695.404.94.276.24.642.361 1.099.361.621 0 1.134-.217 1.538-.65.41-.44.615-.99.615-1.653v-.782Zm12.648 4.421h-2.039v-1.53h-.035c-.657 1.16-1.667 1.74-3.033 1.74-1.107 0-1.995-.4-2.663-1.203-.662-.809-.993-1.907-.993-3.296 0-1.488.366-2.68 1.099-3.577.738-.897 1.72-1.345 2.944-1.345 1.213 0 2.095.486 2.646 1.459h.035V43.22h2.039v13.324ZM130.7 52.43v-1.178c0-.639-.208-1.18-.624-1.626-.416-.445-.946-.668-1.591-.668-.761 0-1.362.284-1.801.852-.434.569-.651 1.357-.651 2.365 0 .914.208 1.637.624 2.17.422.528.988.792 1.697.792.697 0 1.262-.255 1.696-.765.433-.516.65-1.163.65-1.942Zm5.704-6.776a1.24 1.24 0 0 1-.861-.325 1.078 1.078 0 0 1-.352-.826c0-.334.118-.612.352-.835a1.22 1.22 0 0 1 .861-.334c.346 0 .639.111.879.334.24.223.361.5.361.835 0 .316-.121.589-.361.817-.24.223-.533.334-.879.334Zm1.011 10.89h-2.039v-9h2.039v9Zm10.688 0h-2.04v-5.071c0-1.682-.594-2.523-1.784-2.523-.621 0-1.133.235-1.538.703-.404.463-.606 1.05-.606 1.758v5.133h-2.048v-9h2.048v1.494h.035c.674-1.137 1.646-1.705 2.918-1.705.978 0 1.725.32 2.241.958.516.633.774 1.55.774 2.751v5.502Zm10.687-.721c0 3.305-1.661 4.957-4.983 4.957-1.172 0-2.195-.196-3.068-.589v-1.863c.985.563 1.919.844 2.804.844 2.139 0 3.208-1.052 3.208-3.155v-.985h-.035c-.674 1.149-1.688 1.723-3.041 1.723-1.096 0-1.981-.399-2.654-1.195-.668-.803-1.002-1.878-1.002-3.226 0-1.53.36-2.745 1.081-3.648.72-.902 1.711-1.353 2.97-1.353 1.19 0 2.072.486 2.646 1.459h.035v-1.248h2.039v8.28Zm-2.021-3.401v-1.17c0-.632-.211-1.17-.633-1.616a2.04 2.04 0 0 0-1.565-.677c-.773 0-1.38.287-1.819.861-.434.569-.65 1.365-.65 2.39 0 .886.208 1.595.624 2.128.421.527.978.79 1.67.79.703 0 1.274-.251 1.713-.755.44-.51.66-1.16.66-1.951Z" />
		</chakra.svg>
	)
);

export const HeadingLayout5Style1 = forwardRef<IconProps, "svg">(
	(props, ref) => (
		<chakra.svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 240 104"
			{...props}
		>
			{/* eslint-disable-next-line max-len */}
			<path d="M81 46.544h6v6h-6v-6Zm21.681 10h-2.101v-5.467h-5.933v5.467h-2.091V43.94h2.091v5.3h5.933v-5.3h2.101v12.604Zm10.503-3.946h-6.135c.023.832.278 1.473.764 1.925.493.45 1.166.676 2.022.676.961 0 1.843-.287 2.645-.861v1.643c-.82.516-1.904.774-3.251.774-1.325 0-2.365-.407-3.121-1.222-.75-.82-1.125-1.971-1.125-3.454 0-1.4.413-2.54 1.24-3.419.832-.885 1.863-1.327 3.093-1.327 1.231 0 2.183.395 2.857 1.187.674.79 1.011 1.89 1.011 3.295v.783Zm-1.969-1.442c-.006-.732-.179-1.3-.519-1.705-.34-.41-.808-.615-1.406-.615-.586 0-1.084.214-1.494.642-.404.427-.653.987-.747 1.678h4.166Zm10.819 5.388h-1.977v-1.406h-.036c-.621 1.078-1.532 1.617-2.733 1.617-.885 0-1.579-.24-2.083-.72-.498-.481-.747-1.117-.747-1.908 0-1.7.979-2.69 2.936-2.97l2.671-.379c0-1.283-.609-1.925-1.828-1.925-1.072 0-2.039.37-2.9 1.108v-1.784c.949-.563 2.045-.844 3.287-.844 2.273 0 3.41 1.12 3.41 3.357v5.854Zm-1.969-4.421-1.889.264c-.586.076-1.029.22-1.327.43-.293.206-.44.569-.44 1.09 0 .381.135.695.404.94.276.24.642.361 1.099.361.621 0 1.134-.217 1.538-.65.41-.44.615-.99.615-1.653v-.782Zm12.648 4.421h-2.039v-1.53h-.035c-.657 1.16-1.667 1.74-3.033 1.74-1.107 0-1.995-.4-2.663-1.203-.662-.809-.993-1.907-.993-3.296 0-1.488.366-2.68 1.099-3.577.738-.897 1.72-1.345 2.944-1.345 1.213 0 2.095.486 2.646 1.459h.035V43.22h2.039v13.324ZM130.7 52.43v-1.178c0-.639-.208-1.18-.624-1.626-.416-.445-.946-.668-1.591-.668-.761 0-1.362.284-1.801.852-.434.569-.651 1.357-.651 2.365 0 .914.208 1.637.624 2.17.422.528.988.792 1.697.792.697 0 1.262-.255 1.696-.765.433-.516.65-1.163.65-1.942Zm5.704-6.776a1.24 1.24 0 0 1-.861-.325 1.078 1.078 0 0 1-.352-.826c0-.334.118-.612.352-.835a1.22 1.22 0 0 1 .861-.334c.346 0 .639.111.879.334.24.223.361.5.361.835 0 .316-.121.589-.361.817-.24.223-.533.334-.879.334Zm1.011 10.89h-2.039v-9h2.039v9Zm10.688 0h-2.04v-5.071c0-1.682-.594-2.523-1.784-2.523-.621 0-1.133.235-1.538.703-.404.463-.606 1.05-.606 1.758v5.133h-2.048v-9h2.048v1.494h.035c.674-1.137 1.646-1.705 2.918-1.705.978 0 1.725.32 2.241.958.516.633.774 1.55.774 2.751v5.502Zm10.687-.721c0 3.305-1.661 4.957-4.983 4.957-1.172 0-2.195-.196-3.068-.589v-1.863c.985.563 1.919.844 2.804.844 2.139 0 3.208-1.052 3.208-3.155v-.985h-.035c-.674 1.149-1.688 1.723-3.041 1.723-1.096 0-1.981-.399-2.654-1.195-.668-.803-1.002-1.878-1.002-3.226 0-1.53.36-2.745 1.081-3.648.72-.902 1.711-1.353 2.97-1.353 1.19 0 2.072.486 2.646 1.459h.035v-1.248h2.039v8.28Zm-2.021-3.401v-1.17c0-.632-.211-1.17-.633-1.616a2.04 2.04 0 0 0-1.565-.677c-.773 0-1.38.287-1.819.861-.434.569-.65 1.365-.65 2.39 0 .886.208 1.595.624 2.128.421.527.978.79 1.67.79.703 0 1.274-.251 1.713-.755.44-.51.66-1.16.66-1.951Z" />
		</chakra.svg>
	)
);

export const HeadingLayout6Style1 = forwardRef<IconProps, "svg">(
	(props, ref) => (
		<chakra.svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 240 104"
			{...props}
		>
			{/* eslint-disable-next-line max-len */}
			<path fill="#D3D3D3" d="M45 51.5h40v1H45z" />
			<path
				fill="#000"
				d="M99.383 58.5h-1.867v-4.86h-5.274v4.86h-1.86V47.297h1.86v4.71h5.274v-4.71h1.867V58.5Zm9.336-3.508h-5.453c.02.74.247 1.31.679 1.711.438.401 1.037.602 1.797.602.854 0 1.638-.255 2.352-.766V58c-.729.458-1.693.688-2.891.688-1.177 0-2.101-.363-2.773-1.086-.667-.73-1-1.753-1-3.07 0-1.245.367-2.259 1.101-3.04.74-.786 1.657-1.18 2.75-1.18 1.094 0 1.94.352 2.539 1.055.599.703.899 1.68.899 2.93v.695Zm-1.75-1.281c-.005-.651-.159-1.156-.461-1.516-.302-.364-.719-.547-1.25-.547-.521 0-.964.19-1.328.57-.36.381-.581.878-.664 1.493h3.703Zm9.617 4.789h-1.758v-1.25h-.031c-.552.958-1.362 1.438-2.43 1.438-.786 0-1.403-.214-1.851-.641-.443-.427-.664-.992-.664-1.695 0-1.51.869-2.391 2.609-2.641l2.375-.336c0-1.14-.542-1.71-1.625-1.71-.953 0-1.813.327-2.578.983v-1.586c.844-.5 1.818-.75 2.922-.75 2.021 0 3.031.995 3.031 2.985V58.5Zm-1.75-3.93-1.68.235c-.521.067-.914.195-1.179.383-.261.182-.391.505-.391.968 0 .339.12.617.359.836.245.214.571.32.977.32.552 0 1.008-.192 1.367-.578.365-.39.547-.88.547-1.468v-.696Zm11.242 3.93h-1.812v-1.36h-.032c-.583 1.032-1.481 1.547-2.695 1.547-.984 0-1.773-.356-2.367-1.07-.589-.719-.883-1.695-.883-2.93 0-1.322.326-2.382.977-3.18.656-.796 1.528-1.194 2.617-1.194 1.078 0 1.862.432 2.351 1.296h.032v-4.953h1.812V58.5Zm-1.789-3.656v-1.047c0-.568-.185-1.05-.555-1.445-.369-.396-.841-.594-1.414-.594-.677 0-1.211.252-1.601.758-.386.505-.578 1.205-.578 2.101 0 .813.185 1.456.554 1.93.375.469.878.703 1.508.703.62 0 1.123-.227 1.508-.68.385-.458.578-1.034.578-1.726Zm5.07-6.024a1.1 1.1 0 0 1-.765-.289.955.955 0 0 1-.313-.734.98.98 0 0 1 .313-.742c.213-.198.468-.297.765-.297.308 0 .568.099.782.297.213.198.32.445.32.742a.97.97 0 0 1-.32.726 1.108 1.108 0 0 1-.782.297Zm.899 9.68h-1.813v-8h1.813v8Zm9.5 0h-1.813v-4.508c0-1.495-.528-2.242-1.586-2.242-.552 0-1.007.208-1.367.625-.359.411-.539.932-.539 1.563V58.5h-1.82v-8h1.82v1.328h.031c.599-1.01 1.464-1.516 2.594-1.516.87 0 1.534.284 1.992.852.459.563.688 1.378.688 2.445V58.5Zm9.5-.64c0 2.937-1.477 4.406-4.43 4.406-1.042 0-1.95-.175-2.726-.524v-1.656c.875.5 1.705.75 2.492.75 1.901 0 2.851-.935 2.851-2.805v-.875h-.031c-.599 1.021-1.5 1.532-2.703 1.532-.974 0-1.76-.355-2.359-1.063-.594-.714-.891-1.67-.891-2.867 0-1.36.32-2.44.961-3.242.64-.802 1.521-1.203 2.64-1.203 1.058 0 1.842.432 2.352 1.296h.031V50.5h1.813v7.36Zm-1.797-3.024v-1.04c0-.562-.188-1.04-.563-1.437a1.81 1.81 0 0 0-1.39-.601c-.688 0-1.227.255-1.617.765-.386.506-.579 1.214-.579 2.125 0 .787.185 1.417.555 1.891.375.469.87.703 1.485.703.625 0 1.132-.224 1.523-.672.391-.453.586-1.03.586-1.734Z"
			/>
			<path fill="#D3D3D3" d="M155 51.5h40v1h-40z" />
		</chakra.svg>
	)
);

export const HeadingLayout7Style1 = forwardRef<IconProps, "svg">(
	(props, ref) => (
		<chakra.svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 240 104"
			{...props}
		>
			<path
				fill="#000"
				d="M55.383 58.5h-1.867v-4.86h-5.274v4.86h-1.86V47.297h1.86v4.71h5.274v-4.71h1.867V58.5Zm9.336-3.508h-5.453c.02.74.247 1.31.68 1.711.437.401 1.036.602 1.796.602.854 0 1.638-.255 2.352-.766V58c-.73.458-1.693.688-2.89.688-1.178 0-2.102-.363-2.774-1.086-.667-.73-1-1.753-1-3.07 0-1.245.367-2.259 1.101-3.04.74-.786 1.657-1.18 2.75-1.18 1.094 0 1.94.352 2.54 1.055.598.703.898 1.68.898 2.93v.695Zm-1.75-1.281c-.005-.651-.16-1.156-.461-1.516-.302-.364-.719-.547-1.25-.547-.521 0-.964.19-1.328.57-.36.381-.581.878-.664 1.493h3.703Zm9.617 4.789h-1.758v-1.25h-.031c-.552.958-1.362 1.438-2.43 1.438-.786 0-1.404-.214-1.851-.641-.443-.427-.664-.992-.664-1.695 0-1.51.87-2.391 2.609-2.641l2.375-.336c0-1.14-.542-1.71-1.625-1.71-.953 0-1.813.327-2.578.983v-1.586c.844-.5 1.818-.75 2.922-.75 2.02 0 3.03.995 3.03 2.985V58.5Zm-1.75-3.93-1.68.235c-.52.067-.914.195-1.18.383-.26.182-.39.505-.39.968 0 .339.12.617.36.836.244.214.57.32.976.32.552 0 1.008-.192 1.367-.578.365-.39.547-.88.547-1.468v-.696Zm11.242 3.93h-1.812v-1.36h-.032c-.583 1.032-1.481 1.547-2.695 1.547-.984 0-1.773-.356-2.367-1.07-.589-.719-.883-1.695-.883-2.93 0-1.322.326-2.382.977-3.18.656-.796 1.528-1.194 2.617-1.194 1.078 0 1.862.432 2.351 1.296h.032v-4.953h1.812V58.5Zm-1.789-3.656v-1.047c0-.568-.185-1.05-.555-1.445-.37-.396-.84-.594-1.414-.594-.677 0-1.21.252-1.601.758-.386.505-.578 1.205-.578 2.101 0 .813.184 1.456.554 1.93.375.469.878.703 1.508.703.62 0 1.123-.227 1.508-.68.385-.458.578-1.034.578-1.726Zm5.07-6.024c-.296 0-.552-.096-.765-.289a.956.956 0 0 1-.313-.734c0-.297.104-.544.313-.742.213-.198.469-.297.765-.297.308 0 .568.099.782.297a.97.97 0 0 1 .32.742.968.968 0 0 1-.32.726 1.107 1.107 0 0 1-.782.297Zm.899 9.68h-1.813v-8h1.813v8Zm9.5 0h-1.813v-4.508c0-1.495-.528-2.242-1.586-2.242-.552 0-1.007.208-1.367.625-.36.411-.539.932-.539 1.563V58.5h-1.82v-8h1.82v1.328h.031c.6-1.01 1.464-1.516 2.594-1.516.87 0 1.534.284 1.992.852.459.563.688 1.378.688 2.445V58.5Zm9.5-.64c0 2.937-1.477 4.406-4.43 4.406-1.041 0-1.95-.175-2.726-.524v-1.656c.875.5 1.705.75 2.492.75 1.901 0 2.851-.935 2.851-2.805v-.875h-.031c-.599 1.021-1.5 1.532-2.703 1.532-.974 0-1.76-.355-2.36-1.063-.593-.714-.89-1.67-.89-2.867 0-1.36.32-2.44.96-3.242.641-.802 1.522-1.203 2.641-1.203 1.058 0 1.842.432 2.352 1.296h.031V50.5h1.813v7.36Zm-1.797-3.024v-1.04c0-.562-.188-1.04-.563-1.437a1.81 1.81 0 0 0-1.39-.601c-.688 0-1.227.255-1.617.765-.386.506-.579 1.214-.579 2.125 0 .787.185 1.417.555 1.891.375.469.87.703 1.485.703.625 0 1.132-.224 1.523-.672.391-.453.586-1.03.586-1.734Z"
			/>
			<path fill="#D3D3D3" d="M111 53.5h84v1h-84z" />
		</chakra.svg>
	)
);

export const HeadingLayout8Style1 = forwardRef<IconProps, "svg">(
	(props, ref) => (
		<chakra.svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 240 104"
			{...props}
		>
			<mask id="a" fill="#fff">
				<path d="M89 40h37v23H89V40Z" />
			</mask>
			<path fill="#000" d="M126 63v-2H89v4h37v-2Z" mask="url(#a)" />
			<path
				fill="#000"
				d="M99.383 57.5h-1.867v-4.86h-5.274v4.86h-1.86V46.297h1.86v4.71h5.274v-4.71h1.867V57.5Zm9.336-3.508h-5.453c.02.74.247 1.31.679 1.711.438.401 1.037.602 1.797.602.854 0 1.638-.255 2.352-.766V57c-.729.458-1.693.688-2.891.688-1.177 0-2.101-.363-2.773-1.086-.667-.73-1-1.753-1-3.07 0-1.245.367-2.259 1.101-3.04.74-.786 1.657-1.18 2.75-1.18 1.094 0 1.94.352 2.539 1.055.599.703.899 1.68.899 2.93v.695Zm-1.75-1.281c-.005-.651-.159-1.156-.461-1.516-.302-.364-.719-.547-1.25-.547-.521 0-.964.19-1.328.57-.36.381-.581.878-.664 1.493h3.703Zm9.617 4.789h-1.758v-1.25h-.031c-.552.958-1.362 1.438-2.43 1.438-.786 0-1.403-.214-1.851-.641-.443-.427-.664-.992-.664-1.695 0-1.51.869-2.391 2.609-2.641l2.375-.336c0-1.14-.542-1.71-1.625-1.71-.953 0-1.813.327-2.578.983v-1.586c.844-.5 1.818-.75 2.922-.75 2.021 0 3.031.995 3.031 2.985V57.5Zm-1.75-3.93-1.68.235c-.521.067-.914.195-1.179.383-.261.182-.391.505-.391.968 0 .339.12.617.359.836.245.214.571.32.977.32.552 0 1.008-.192 1.367-.578.365-.39.547-.88.547-1.468v-.696Zm11.242 3.93h-1.812v-1.36h-.032c-.583 1.032-1.481 1.547-2.695 1.547-.984 0-1.773-.356-2.367-1.07-.589-.719-.883-1.695-.883-2.93 0-1.322.326-2.382.977-3.18.656-.796 1.528-1.194 2.617-1.194 1.078 0 1.862.432 2.351 1.296h.032v-4.953h1.812V57.5Zm-1.789-3.656v-1.047c0-.568-.185-1.05-.555-1.445-.369-.396-.841-.594-1.414-.594-.677 0-1.211.252-1.601.758-.386.505-.578 1.205-.578 2.101 0 .813.185 1.456.554 1.93.375.469.878.703 1.508.703.62 0 1.123-.227 1.508-.68.385-.458.578-1.034.578-1.726Zm5.07-6.024a1.1 1.1 0 0 1-.765-.289.955.955 0 0 1-.313-.734.98.98 0 0 1 .313-.742c.213-.198.468-.297.765-.297.308 0 .568.099.782.297.213.198.32.445.32.742a.97.97 0 0 1-.32.726 1.108 1.108 0 0 1-.782.297Zm.899 9.68h-1.813v-8h1.813v8Zm9.5 0h-1.813v-4.508c0-1.495-.528-2.242-1.586-2.242-.552 0-1.007.208-1.367.625-.359.411-.539.932-.539 1.563V57.5h-1.82v-8h1.82v1.328h.031c.599-1.01 1.464-1.516 2.594-1.516.87 0 1.534.284 1.992.852.459.563.688 1.378.688 2.445V57.5Zm9.5-.64c0 2.937-1.477 4.406-4.43 4.406-1.042 0-1.95-.175-2.726-.524v-1.656c.875.5 1.705.75 2.492.75 1.901 0 2.851-.935 2.851-2.805v-.875h-.031c-.599 1.021-1.5 1.532-2.703 1.532-.974 0-1.76-.355-2.359-1.063-.594-.714-.891-1.67-.891-2.867 0-1.36.32-2.44.961-3.242.64-.802 1.521-1.203 2.64-1.203 1.058 0 1.842.432 2.352 1.296h.031V49.5h1.813v7.36Zm-1.797-3.024v-1.04c0-.562-.188-1.04-.563-1.437a1.81 1.81 0 0 0-1.39-.601c-.688 0-1.227.255-1.617.765-.386.506-.579 1.214-.579 2.125 0 .787.185 1.417.555 1.891.375.469.87.703 1.485.703.625 0 1.132-.224 1.523-.672.391-.453.586-1.03.586-1.734Z"
			/>
		</chakra.svg>
	)
);

export const HeadingLayout9Style1 = forwardRef<IconProps, "svg">(
	(props, ref) => (
		<chakra.svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 240 104"
			{...props}
		>
			<mask id="a" fill="#fff">
				<path d="M45 41h150v23H45V41Z" />
			</mask>
			<path fill="#D3D3D3" d="M45 41v1h150v-2H45v1Z" mask="url(#a)" />
			<path
				fill="#000"
				d="M55.383 60h-1.867v-4.86h-5.274V60h-1.86V48.797h1.86v4.71h5.274v-4.71h1.867V60Zm9.336-3.508h-5.453c.02.74.247 1.31.68 1.711.437.401 1.036.602 1.796.602.854 0 1.638-.255 2.352-.766V59.5c-.73.458-1.693.688-2.89.688-1.178 0-2.102-.363-2.774-1.086-.667-.73-1-1.753-1-3.07 0-1.245.367-2.259 1.101-3.04.74-.786 1.657-1.18 2.75-1.18 1.094 0 1.94.352 2.54 1.055.598.703.898 1.68.898 2.93v.695Zm-1.75-1.281c-.005-.651-.16-1.156-.461-1.516-.302-.364-.719-.547-1.25-.547-.521 0-.964.19-1.328.57-.36.381-.581.878-.664 1.493h3.703ZM72.586 60h-1.758v-1.25h-.031c-.552.958-1.362 1.438-2.43 1.438-.786 0-1.404-.214-1.851-.641-.443-.427-.664-.992-.664-1.695 0-1.51.87-2.391 2.609-2.641l2.375-.336c0-1.14-.542-1.71-1.625-1.71-.953 0-1.813.327-2.578.983v-1.586c.844-.5 1.818-.75 2.922-.75 2.02 0 3.03.995 3.03 2.985V60Zm-1.75-3.93-1.68.235c-.52.067-.914.195-1.18.383-.26.182-.39.505-.39.968 0 .339.12.617.36.836.244.214.57.32.976.32.552 0 1.008-.192 1.367-.578.365-.39.547-.88.547-1.468v-.696ZM82.078 60h-1.812v-1.36h-.032c-.583 1.032-1.481 1.547-2.695 1.547-.984 0-1.773-.356-2.367-1.07-.589-.719-.883-1.695-.883-2.93 0-1.322.326-2.382.977-3.18.656-.796 1.528-1.194 2.617-1.194 1.078 0 1.862.432 2.351 1.296h.032v-4.953h1.812V60Zm-1.789-3.656v-1.047c0-.568-.185-1.05-.555-1.445-.37-.396-.84-.594-1.414-.594-.677 0-1.21.252-1.601.758-.386.505-.578 1.205-.578 2.101 0 .813.184 1.456.554 1.93.375.469.878.703 1.508.703.62 0 1.123-.227 1.508-.68.385-.458.578-1.034.578-1.726Zm5.07-6.024c-.296 0-.552-.096-.765-.289a.956.956 0 0 1-.313-.734c0-.297.104-.544.313-.742.213-.198.469-.297.765-.297.308 0 .568.099.782.297a.97.97 0 0 1 .32.742.968.968 0 0 1-.32.726 1.107 1.107 0 0 1-.782.297Zm.899 9.68h-1.813v-8h1.813v8Zm9.5 0h-1.813v-4.508c0-1.495-.528-2.242-1.586-2.242-.552 0-1.007.208-1.367.625-.36.411-.539.932-.539 1.563V60h-1.82v-8h1.82v1.328h.031c.6-1.01 1.464-1.516 2.594-1.516.87 0 1.534.284 1.992.852.459.563.688 1.378.688 2.445V60Zm9.5-.64c0 2.937-1.477 4.406-4.43 4.406-1.041 0-1.95-.175-2.726-.524v-1.656c.875.5 1.705.75 2.492.75 1.901 0 2.851-.935 2.851-2.805v-.875h-.031c-.599 1.021-1.5 1.532-2.703 1.532-.974 0-1.76-.355-2.36-1.063-.593-.714-.89-1.67-.89-2.867 0-1.36.32-2.44.96-3.242.641-.802 1.522-1.203 2.641-1.203 1.058 0 1.842.432 2.352 1.296h.031V52h1.813v7.36Zm-1.797-3.024v-1.04c0-.562-.188-1.04-.563-1.437a1.81 1.81 0 0 0-1.39-.601c-.688 0-1.227.255-1.617.765-.386.506-.579 1.214-.579 2.125 0 .787.185 1.417.555 1.891.375.469.87.703 1.485.703.625 0 1.132-.224 1.523-.672.391-.453.586-1.03.586-1.734Z"
			/>
		</chakra.svg>
	)
);

export const BannerPostLayout1Style1 = forwardRef<IconProps, "svg">(
	(props, ref) => (
		<chakra.svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 240 104"
			{...props}
		>
			<path
				fill="#BDBDBD"
				d="M113.667 80.905H82V22.32h31.667v58.584Zm23.75-58.584h-20.584v58.584h20.584V22.32Zm20.583 0h-17.417V50.03H158V22.32Zm0 30.954h-17.417v27.709H158V53.275Z"
			></path>
		</chakra.svg>
	)
);

export const BannerPostLayout1Style2 = forwardRef<IconProps, "svg">(
	(props, ref) => (
		<chakra.svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 240 104"
			{...props}
		>
			<path
				fill="#BDBDBD"
				d="M113.667 81.29H82V22.705h31.667V81.29ZM158 22.705h-20.583V81.29H158V22.705Zm-23.75 0h-17.417v27.708h17.417V22.705Zm0 30.954h-17.417V81.37h17.417V53.66Z"
			/>{" "}
		</chakra.svg>
	)
);

export const BannerPostLayout2Style1 = forwardRef<IconProps, "svg">(
	(props, ref) => (
		<chakra.svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 240 104"
			{...props}
		>
			<path
				fill="#BDBDBD"
				d="M99.417 80.68H82V22.016h17.417v58.662Zm38-58.663h-34.834v58.662h34.834V22.017Zm20.583 0h-17.417v58.662H158V22.017Z"
			></path>
		</chakra.svg>
	)
);

export const BannerPostLayout2Style2 = forwardRef<IconProps, "svg">(
	(props, ref) => (
		<chakra.svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 240 104"
			{...props}
		>
			<path
				fill="#BDBDBD"
				d="M82 22.05h23.333V79H82V22.05Zm26.333 0h23.334V79h-23.334V22.05Zm26.334 0H158V79h-23.333V22.05Z"
			></path>
		</chakra.svg>
	)
);

export const BannerPostLayout2Style3 = forwardRef<IconProps, "svg">(
	(props, ref) => (
		<chakra.svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 240 104"
			{...props}
		>
			<path
				fill="#BDBDBD"
				d="M82 22h43v59H82zm46 0h30v28h-30zm0 31h30v28h-30z"
			/>
		</chakra.svg>
	)
);

export const PostVideoPreset1 = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 240 104"
		{...props}
	>
		<path fill="#BDBDBD" d="M74 25h47v54H74zM124 25h20v16h-20z" />
		<rect width="20" height="2" x="146" y="29.5" fill="#BDBDBD" rx="1" />
		<rect
			width="13"
			height="2"
			x="146"
			y="34.5"
			fill="#BDBDBD"
			opacity=".8"
			rx="1"
		/>
		<path fill="#BDBDBD" d="M124 44h20v16h-20z" />
		<rect width="20" height="2" x="146" y="48.5" fill="#BDBDBD" rx="1" />
		<rect
			width="13"
			height="2"
			x="146"
			y="53.5"
			fill="#BDBDBD"
			opacity=".8"
			rx="1"
		/>
		<path fill="#BDBDBD" d="M124 63h20v16h-20z" />
		<rect width="20" height="2" x="146" y="67.5" fill="#BDBDBD" rx="1" />
		<rect
			width="13"
			height="2"
			x="146"
			y="72.5"
			fill="#BDBDBD"
			opacity=".8"
			rx="1"
		/>
	</chakra.svg>
));

export const PostVideoPreset2 = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 240 104"
		{...props}
	>
		<path
			fill="#BDBDBD"
			d="M74 25h47v54H74zm50 0h20v16.5h-20zm0 20.5c0-.552.437-1 .975-1h17.55c.538 0 .975.448.975 1s-.437 1-.975 1h-17.55a.988.988 0 0 1-.975-1Z"
		/>
		<rect
			fill="#BDBDBD"
			width="13"
			height="2"
			x="124"
			y="48.5"
			opacity=".8"
			rx="1"
		/>
		<path fill="#BDBDBD" d="M146.5 25h20v16.5h-20z" />
		<rect
			fill="#BDBDBD"
			width="19.5"
			height="2"
			x="146.5"
			y="44.5"
			rx="1"
		/>
		<rect
			fill="#BDBDBD"
			width="13"
			height="2"
			x="146.5"
			y="48.5"
			opacity=".8"
			rx="1"
		/>
		<path
			fill="#BDBDBD"
			d="M124 53.5h20V70h-20zm0 20.5c0-.552.437-1 .975-1h17.55c.538 0 .975.448.975 1s-.437 1-.975 1h-17.55a.988.988 0 0 1-.975-1Z"
		/>
		<rect
			fill="#BDBDBD"
			width="13"
			height="2"
			x="124"
			y="77"
			opacity=".8"
			rx="1"
		/>
		<path fill="#BDBDBD" d="M146.5 53.5h20V70h-20z" />
		<rect fill="#BDBDBD" width="19.5" height="2" x="146.5" y="73" rx="1" />
		<rect
			fill="#BDBDBD"
			width="13"
			height="2"
			x="146.5"
			y="77"
			opacity=".8"
			rx="1"
		/>
	</chakra.svg>
));

export const PostVideoPreset3 = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 240 104"
		{...props}
	>
		<path fill="#BDBDBD" d="M74 25h51v54H74V25Z" />
		<g fill="#fff" opacity=".8">
			<path d="M78 62.25c0-.69.56-1.25 1.25-1.25h36.5a1.25 1.25 0 0 1 0 2.5h-36.5c-.69 0-1.25-.56-1.25-1.25ZM78 67.5a1 1 0 0 1 1-1h31a1 1 0 0 1 0 2H79a1 1 0 0 1-1-1ZM78 73.25c0-.69.56-1.25 1.25-1.25h10.5a1.25 1.25 0 1 1 0 2.5h-10.5c-.69 0-1.25-.56-1.25-1.25Z" />
		</g>
		<path fill="#BDBDBD" d="M128 25h38v25h-38z" />
		<rect
			width="28"
			height="2"
			x="132"
			y="38"
			fill="#fff"
			opacity=".8"
			rx="1"
		/>
		<rect
			width="13"
			height="2.5"
			x="132"
			y="43.5"
			fill="#fff"
			opacity=".8"
			rx="1.25"
		/>
		<path fill="#BDBDBD" d="M128 53h38v26h-38z" />
		<rect
			width="28"
			height="2"
			x="132"
			y="67"
			fill="#fff"
			opacity=".8"
			rx="1"
		/>
		<rect
			width="13"
			height="2.5"
			x="132"
			y="72.5"
			fill="#fff"
			opacity=".8"
			rx="1.25"
		/>
	</chakra.svg>
));

export const GridModuleLayout1Style1 = forwardRef<IconProps, "svg">(
	(props, ref) => (
		<chakra.svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 240 104"
			{...props}
		>
			<path
				fill="#BDBDBD"
				fillRule="evenodd"
				d="m53.846 73 33.077-.058V30H53.846v43Zm1.892-8.846h25.533v-2.32H55.738v2.32Zm0 2.879H72.23v2.32H55.738v-2.32Z"
				clipRule="evenodd"
			></path>
			<path
				fill="#BDBDBD"
				fillRule="evenodd"
				d="M86.923 73 120 72.942V30H86.923v43Zm2.588-8.846h25.533v-2.32H89.511v2.32Zm0 2.879h16.562v2.32H89.511v-2.32Z"
				clipRule="evenodd"
				opacity=".8"
			></path>
			<path
				fill="#BDBDBD"
				fillRule="evenodd"
				d="m120 73 33.077-.058V30H120v43Zm2.553-8.846h25.533v-2.32h-25.533v2.32Zm0 2.879h16.492v2.32h-16.492v-2.32Z"
				clipRule="evenodd"
			></path>
			<path
				fill="#BDBDBD"
				fillRule="evenodd"
				d="M153.077 30h33.077v43h-33.077V30Zm2.821 34.154h25.533v-2.32h-25.533v2.32Zm0 2.879h16.492v2.32h-16.492v-2.32Z"
				clipRule="evenodd"
				opacity=".8"
			></path>
		</chakra.svg>
	)
);

export const GridModuleLayout1Style2 = forwardRef<IconProps, "svg">(
	(props, ref) => (
		<chakra.svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 240 104"
			{...props}
		>
			<path
				fill="#BDBDBD"
				fillRule="evenodd"
				d="m53.701 73.045 51.356-.058V30.045H53.701v43Zm1.892-8.843h43.603v-2.321H55.593v2.321Zm0 2.878h24.802v2.322H55.593V67.08Z"
				clipRule="evenodd"
			></path>
			<path
				fill="#BDBDBD"
				fillRule="evenodd"
				d="m105.057 73.045 27.077-.058V30.045h-27.077v43Zm1.718-8.843h22.841v-2.321h-22.841v2.321Zm0 2.878h11.42v2.322h-11.42V67.08Z"
				clipRule="evenodd"
				opacity=".8"
			></path>
			<path
				fill="#BDBDBD"
				fillRule="evenodd"
				d="m132.134 73.045 27.088-.058V30.045h-27.088v43Zm1.88-8.843h22.794v-2.321h-22.794v2.321Zm.058 2.878h11.606v2.322h-11.606V67.08Z"
				clipRule="evenodd"
			></path>
			<path
				fill="#BDBDBD"
				fillRule="evenodd"
				d="M159.222 30.045h27.077v43h-27.077v-43Zm2.333 34.157h22.214v-2.321h-22.214v2.321Zm0 2.878h10.805v2.322h-10.805V67.08Z"
				clipRule="evenodd"
				opacity=".8"
			></path>
		</chakra.svg>
	)
);

export const GridModuleLayout2Style1 = forwardRef<IconProps, "svg">(
	(props, ref) => (
		<chakra.svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 240 104"
			{...props}
		>
			<path
				fill="#BDBDBD"
				d="m85.882 63.32-34.117.048V30.687h34.117V63.32Zm-5.83 2.598H53.717v2.394h26.337v-2.394Zm-9.325 7.769h-17.01v-2.394h17.01v2.394Z"
			></path>
			<path
				fill="#BDBDBD"
				d="m120 63.32-34.118.036V30.687H120V63.32Z"
				opacity=".8"
			></path>
			<path
				fill="#BDBDBD"
				d="M114.888 68.312H88.552v-2.394h26.336v2.394Zm-9.253 2.969H88.552v2.394h17.083V71.28Zm48.482-7.961H120V30.687h34.117V63.32Zm-5.147 2.598h-26.336v2.394h26.336v-2.394Zm-9.326 7.769h-17.01v-2.394h17.01v2.394Z"
			></path>
			<path
				fill="#BDBDBD"
				d="M188.235 30.687h-34.118v32.681h34.118V30.687Z"
				opacity=".8"
			></path>
			<path
				fill="#BDBDBD"
				d="M183.363 68.312h-26.337v-2.394h26.337v2.394Zm-9.326 2.98h-17.011v2.395h17.011v-2.394Z"
			></path>
		</chakra.svg>
	)
);

export const FeaturedPostLayout1Style1 = forwardRef<IconProps, "svg">(
	(props, ref) => (
		<chakra.svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 240 104"
			{...props}
			fill="#BDBDBD"
		>
			<path
				fill="#BDBDBD"
				d="M145 41.87H95V22.32h50v19.55Zm-8 6.515H95v-3.258h42v3.258Zm-20 6.516H95v-3.258h22v3.258Zm-6 13.032H95V58.16h16v9.774Zm34-5.734h-30v-2.444h30V62.2Zm-11.48 4.561H115v-2.443h18.52v2.443ZM111 80.981H95v-9.774h16v9.774Zm34-5.75h-30v-2.444h30v2.444Zm-11.48 4.561H115V77.35h18.52v2.443Z"
			></path>
		</chakra.svg>
	)
);

export const FeaturedPostLayout2Style1 = forwardRef<IconProps, "svg">(
	(props, ref) => (
		<chakra.svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 240 104"
			{...props}
			fill="#BDBDBD"
		>
			{/* eslint-disable-next-line max-len */}
			<path
				fill="#BDBDBD"
				d="M122.75 59.368H76.921V22.706h45.829v36.662Zm-34.83 3.667H76.921V66.7h11v-3.666Zm27.497 10.999H76.921v-3.667h38.496v3.666Zm-18.331 7.332H76.92V77.7h20.165v3.666Zm41.685-47.661h-12.355V22.706h12.355v10.999Zm24.307-6.251h-22.309v-2.75h22.309v2.75Zm-5.499 4.271h-16.81v-2.75h16.718l.092 2.75Zm-18.808 17.873h-12.355V38.599h12.355v10.999Zm24.307-6.251h-22.309v-2.75h22.309v2.75Zm-5.499 4.253h-16.81v-2.75h16.718l.092 2.75Zm-18.808 17.873h-12.355V54.474h12.355v10.999Zm24.307-6.233h-22.309v-2.658h22.309v2.658Zm-5.499 4.253h-16.81v-2.75h16.718l.092 2.75Zm-18.808 17.873h-12.355V70.367h12.355v11Zm24.307-6.25h-22.309v-2.75h22.309v2.75Zm-5.499 4.27h-16.81v-2.75h16.718l.092 2.75Z"
			></path>
		</chakra.svg>
	)
);

export const FeaturedPostLayout3Style1 = forwardRef<IconProps, "svg">(
	(props, ref) => (
		<chakra.svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 240 104"
			{...props}
			fill="#BDBDBD"
		>
			<path fill="#BDBDBD" d="M73 25h46v38.5H73z" />
			<rect
				fill="#BDBDBD"
				width="46"
				height="2.5"
				x="73"
				y="66.5"
				rx="1.25"
			/>
			<rect
				fill="#BDBDBD"
				width="38"
				height="2"
				x="73"
				y="71.5"
				opacity=".8"
				rx="1"
			/>
			<rect
				fill="#BDBDBD"
				width="13"
				height="2.5"
				x="73"
				y="76.5"
				opacity=".8"
				rx="1.25"
			/>
			<path
				fill="#BDBDBD"
				d="M123 25h20v16h-20zm0 20a1 1 0 0 1 1-1h18a1 1 0 0 1 0 2h-18a1 1 0 0 1-1-1Z"
			/>
			<rect
				fill="#BDBDBD"
				width="13"
				height="2"
				x="123"
				y="48"
				opacity=".8"
				rx="1"
			/>
			<path fill="#BDBDBD" d="M147 25h20v16h-20z" />
			<rect fill="#BDBDBD" width="20" height="2" x="147" y="44" rx="1" />
			<rect
				fill="#BDBDBD"
				width="13"
				height="2"
				x="147"
				y="48"
				opacity=".8"
				rx="1"
			/>
			<path
				fill="#BDBDBD"
				d="M123 54h20v16h-20zm0 20a1 1 0 0 1 1-1h18a1 1 0 0 1 0 2h-18a1 1 0 0 1-1-1Z"
			/>
			<rect
				fill="#BDBDBD"
				width="13"
				height="2"
				x="123"
				y="77"
				opacity=".8"
				rx="1"
			/>
			<path fill="#BDBDBD" d="M147 54h20v16h-20z" />
			<rect fill="#BDBDBD" width="20" height="2" x="147" y="73" rx="1" />
			<rect
				fill="#BDBDBD"
				width="13"
				height="2"
				x="147"
				y="77"
				opacity=".8"
				rx="1"
			/>
		</chakra.svg>
	)
);

export const FeaturedPostLayout4Style1 = forwardRef<IconProps, "svg">(
	(props, ref) => (
		<chakra.svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 240 104"
			{...props}
			fill="#BDBDBD"
		>
			{/* eslint-disable-next-line max-len */}
			<path
				fill="#BDBDBD"
				d="M74 25h28v16H74zm0 20c0-.552.627-1 1.4-1h25.2c.773 0 1.4.448 1.4 1s-.627 1-1.4 1H75.4c-.773 0-1.4-.448-1.4-1Z"
			/>
			<rect
				fill="#BDBDBD"
				width="13"
				height="2"
				x="74"
				y="48"
				opacity=".8"
				rx="1"
			/>
			<path
				fill="#BDBDBD"
				d="M106 25h28v16h-28zm0 20c0-.552.627-1 1.4-1h25.2c.773 0 1.4.448 1.4 1s-.627 1-1.4 1h-25.2c-.773 0-1.4-.448-1.4-1Z"
			/>
			<rect
				fill="#BDBDBD"
				width="13"
				height="2"
				x="106"
				y="48"
				opacity=".8"
				rx="1"
			/>
			<path fill="#BDBDBD" d="M138 25h28v16h-28z" />
			<rect fill="#BDBDBD" width="28" height="2" x="138" y="44" rx="1" />
			<rect
				fill="#BDBDBD"
				width="13"
				height="2"
				x="138"
				y="48"
				opacity=".8"
				rx="1"
			/>
			<path
				fill="#BDBDBD"
				d="M74 54h20v16H74zm0 20a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H75a1 1 0 0 1-1-1Z"
			/>
			<rect
				fill="#BDBDBD"
				width="13"
				height="2"
				x="74"
				y="77"
				opacity=".8"
				rx="1"
			/>
			<path fill="#BDBDBD" d="M98 54h20v16H98z" />
			<rect fill="#BDBDBD" width="20" height="2" x="98" y="73" rx="1" />
			<rect
				fill="#BDBDBD"
				width="13"
				height="2"
				x="98"
				y="77"
				opacity=".8"
				rx="1"
			/>
			<path fill="#BDBDBD" d="M122 54h20v16h-20z" />
			<rect fill="#BDBDBD" width="20" height="2" x="122" y="73" rx="1" />
			<rect
				fill="#BDBDBD"
				width="13"
				height="2"
				x="122"
				y="77"
				opacity=".8"
				rx="1"
			/>
			<path fill="#BDBDBD" d="M146 54h20v16h-20z" />
			<rect fill="#BDBDBD" width="20" height="2" x="146" y="73" rx="1" />
			<rect
				fill="#BDBDBD"
				width="13"
				height="2"
				x="146"
				y="77"
				opacity=".8"
				rx="1"
			/>
		</chakra.svg>
	)
);

export const FeaturedPostLayout5Style1 = forwardRef<IconProps, "svg">(
	(props, ref) => (
		<chakra.svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 240 104"
			{...props}
			fill="#BDBDBD"
		>
			{/* eslint-disable-next-line max-len */}
			<path
				fill="#BDBDBD"
				d="M74 25h47v54H74V25Zm50 0h20v16h-20V25Zm22 5.5a1 1 0 0 1 1-1h18a1 1 0 0 1 0 2h-18a1 1 0 0 1-1-1Zm0 5a1 1 0 0 1 1-1h11a1 1 0 0 1 0 2h-11a1 1 0 0 1-1-1ZM124 44h20v16h-20V44Zm22 5.5a1 1 0 0 1 1-1h18a1 1 0 0 1 0 2h-18a1 1 0 0 1-1-1Zm0 5a1 1 0 0 1 1-1h11a1 1 0 0 1 0 2h-11a1 1 0 0 1-1-1ZM124 63h20v16h-20V63Zm22 5.5a1 1 0 0 1 1-1h18a1 1 0 0 1 0 2h-18a1 1 0 0 1-1-1Zm0 5a1 1 0 0 1 1-1h11a1 1 0 0 1 0 2h-11a1 1 0 0 1-1-1Z"
			/>
			<path
				fill="#fff"
				d="M78 62.25c0-.69.56-1.25 1.25-1.25h36.5a1.25 1.25 0 0 1 0 2.5h-36.5c-.69 0-1.25-.56-1.25-1.25Zm0 5.25a1 1 0 0 1 1-1h31a1 1 0 0 1 0 2H79a1 1 0 0 1-1-1Zm0 5.75c0-.69.56-1.25 1.25-1.25h10.5a1.25 1.25 0 1 1 0 2.5h-10.5c-.69 0-1.25-.56-1.25-1.25Z"
			/>
		</chakra.svg>
	)
);

export const FeaturedPostLayout6Style1 = forwardRef<IconProps, "svg">(
	(props, ref) => (
		<chakra.svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 240 104"
			{...props}
			fill="#BDBDBD"
		>
			{/* eslint-disable-next-line max-len */}
			<path
				fill="#BDBDBD"
				d="M74 25h60v34H74V25Zm64 6.5c0-.828.769-1.5 1.1-1.5h10.8c.331 0 1.1.672 1.1 1.5s-.769 1.5-1.1 1.5h-10.8c-.331 0-1.1-.672-1.1-1.5ZM90 66c0-.552.269-1 .6-1h10.8c.331 0 .6.448.6 1s-.269 1-.6 1H90.6c-.331 0-.6-.448-.6-1Zm42 0c0-.552.269-1 .6-1h10.8c.331 0 .6.448.6 1s-.269 1-.6 1h-10.8c-.331 0-.6-.448-.6-1Zm42 0c0-.552.269-1 .6-1h10.8c.331 0 .6.448.6 1s-.269 1-.6 1h-10.8c-.331 0-.6-.448-.6-1Zm-36-27.5c0-.828.298-1.5 1.9-1.5h52.2c1.602 0 1.9.672 1.9 1.5s-.298 1.5-1.9 1.5h-52.2c-1.602 0-1.9-.672-1.9-1.5ZM90 70c0-.552.493-1 1.1-1h19.8c.608 0 1.1.448 1.1 1s-.492 1-1.1 1H91.1c-.607 0-1.1-.448-1.1-1Zm42 0c0-.552.492-1 1.1-1h19.8c.608 0 1.1.448 1.1 1s-.492 1-1.1 1h-19.8c-.608 0-1.1-.448-1.1-1Zm42 0c0-.552.492-1 1.1-1h19.8c.608 0 1.1.448 1.1 1s-.492 1-1.1 1h-19.8c-.608 0-1.1-.448-1.1-1Zm-36-24.5c0-.828.53-1.5 1.8-1.5h41.4c1.27 0 1.8.672 1.8 1.5s-.53 1.5-1.8 1.5h-41.4c-1.27 0-1.8-.672-1.8-1.5Zm0 7c0-.828.858-1.5 1.3-1.5h14.4c.442 0 1.3.672 1.3 1.5s-.858 1.5-1.3 1.5h-14.4c-.442 0-1.3-.672-1.3-1.5ZM90 74c0-.552.224-1 .5-1h9c.276 0 .5.448.5 1s-.224 1-.5 1h-9c-.276 0-.5-.448-.5-1Zm42 0c0-.552.224-1 .5-1h9c.276 0 .5.448.5 1s-.224 1-.5 1h-9c-.276 0-.5-.448-.5-1Zm42 0c0-.552.224-1 .5-1h9c.276 0 .5.448.5 1s-.224 1-.5 1h-9c-.276 0-.5-.448-.5-1ZM74 63h14v14H74V63Zm42 0h14v14h-14V63Zm42 0h14v14h-14V63Z"
			/>
		</chakra.svg>
	)
);

export const PostListLayout1Style1 = forwardRef<IconProps, "svg">(
	(props, ref) => (
		<chakra.svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 240 104"
			{...props}
			fill="#BDBDBD"
		>
			<path
				fill="#BDBDBD"
				d="M112.667 49.497H76.005V22h36.662v27.497Zm14.262-22.95h-10.595v3.665h10.595v-3.666Zm37.066 7.332h-47.661v3.666h47.661v-3.666Zm-15.893 7.332h-31.768v3.666h31.768v-3.666ZM112.667 80.66H76.005V53.163h36.662V80.66Zm14.262-22.95h-10.595v3.666h10.595v-3.667Zm37.066 7.332h-47.661v3.666h47.661v-3.666Zm-15.893 7.332h-31.768v3.666h31.768v-3.666Z"
			></path>
		</chakra.svg>
	)
);

export const PostListLayout1Style2 = forwardRef<IconProps, "svg">(
	(props, ref) => (
		<chakra.svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 240 104"
			{...props}
			fill="#BDBDBD"
		>
			<path
				fill="#BDBDBD"
				d="M74.981 61.08H53.838V42.26h21.143v18.82Zm41.596-10.697H78.401v-4.705h38.176v4.706Zm-9.41 7.31H78.401v-4.706h28.609l.157 4.706Zm37.399 3.387h-21.143V42.26h21.143v18.822Zm41.596-10.696h-38.177v-4.706h38.177v4.706Zm-9.411 7.309h-28.766v-4.706h28.609l.157 4.706Z"
			></path>
		</chakra.svg>
	)
);

export const PostListLayout1Style3 = forwardRef<IconProps, "svg">(
	(props, ref) => (
		<chakra.svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 240 104"
			{...props}
			fill="#BDBDBD"
		>
			<path
				fill="#BDBDBD"
				d="M76 22h37v28H76V22Zm41 6.25h12v3h-12v-3Zm0 6h47v3.5h-47v-3.5Zm0 6.5h32v3h-32v-3Zm-41 19.5h12v3H76v-3Zm0 6h47v3.5H76v-3.5Zm0 6.5h32v3H76v-3ZM127 54h37v28h-37V54Z"
			/>
		</chakra.svg>
	)
);

export const PostListLayout2Style1 = forwardRef<IconProps, "svg">(
	(props, ref) => (
		<chakra.svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 240 104"
			{...props}
			fill="#BDBDBD"
		>
			<path
				fill="#BDBDBD"
				d="M136.76 37.469h-33.52V22.385h33.52v15.084Zm-5.028 3.436H103.24v3.352h28.492v-3.352Zm-10.056 6.62H103.24v3.352h18.436v-3.352Zm15.084 21.788h-33.52V54.229h33.52v15.084Zm-1.676 3.352H103.24v3.352h31.844v-3.352Zm-13.408 5.028H103.24v3.352h18.436v-3.352Z"
			></path>
		</chakra.svg>
	)
);

export const CategoryListLayout1Style1 = forwardRef<IconProps, "svg">(
	(props, ref) => (
		<chakra.svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 240 104"
			{...props}
		>
			<path
				fill="#BDBDBD"
				fillRule="evenodd"
				d="M143.705 36h-74.11v14h74.11V36Zm-39.109 5.545h-30.19v2.91h30.19v-2.91Z"
				clipRule="evenodd"
				opacity=".8"
			></path>
			<path
				fill="#BDBDBD"
				fillRule="evenodd"
				d="M171.115 36h-27.41v14h27.41V36Zm-4.655 5.545h-18.1v2.91h18.1v-2.91Z"
				clipRule="evenodd"
			></path>
			<path
				fill="#BDBDBD"
				fillRule="evenodd"
				d="M143.705 54h-74.11v14h74.11V54Zm-39.109 5.545h-30.19v2.91h30.19v-2.91Z"
				clipRule="evenodd"
				opacity=".8"
			></path>
			<path
				fill="#BDBDBD"
				fillRule="evenodd"
				d="M171.115 54h-27.41v14h27.41V54Zm-4.655 5.545h-18.1v2.91h18.1v-2.91Z"
				clipRule="evenodd"
			></path>
		</chakra.svg>
	)
);

export const CategoryListLayout2Style1 = forwardRef<IconProps, "svg">(
	(props, ref) => (
		<chakra.svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 240 104"
			{...props}
		>
			<path
				fill="#BDBDBD"
				fillRule="evenodd"
				d="m66.385 73.358 33.077-.058V30.358H66.385v43Zm1.892-22.94H93.81v-2.32H68.277v2.32Zm0 2.879h16.492v2.321H68.277v-2.321Z"
				clipRule="evenodd"
			></path>
			<path
				fill="#BDBDBD"
				fillRule="evenodd"
				d="m103.462 73.358 33.076-.058V30.358h-33.076v43Zm2.588-22.94h25.533v-2.32H106.05v2.32Zm0 2.879h16.561v2.321H106.05v-2.321Z"
				clipRule="evenodd"
				opacity=".8"
			></path>
			<path
				fill="#BDBDBD"
				fillRule="evenodd"
				d="m140.538 73.358 33.077-.058V30.358h-33.077v43Zm1.892-22.94h25.533v-2.32H142.43v2.32Zm0 2.879h16.492v2.321H142.43v-2.321Z"
				clipRule="evenodd"
			></path>
		</chakra.svg>
	)
);

export const CategoryListLayout3Style1 = forwardRef<IconProps, "svg">(
	(props, ref) => (
		<chakra.svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 240 104"
			{...props}
		>
			<path fill="#BDBDBD" d="M69.3 50.9h101.5v.5H69.3v-.5z"></path>
			<path
				fill="#BDBDBD"
				d="M74.4 42h30.2v2.9H74.4V42zm0 15.4h30.2v2.9H74.4v-2.9z"
				opacity=".8"
			></path>
			<path
				fill="#BDBDBD"
				d="M147.5 42h18.1v2.9h-18.1V42zm0 15.4h18.1v2.9h-18.1v-2.9z"
			></path>
		</chakra.svg>
	)
);

export const BottomSeparator_Curve1 = forwardRef<IconProps, "svg">(
	(props, ref) => (
		<chakra.svg
			width="112"
			height="101"
			viewBox="0 0 112 101"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
			ref={ref}
		>
			<g clipPath="url(#clip0_5_3661)">
				<path
					d="M108.267 100.668H3.73333C1.67147 100.668 0 98.9965 0 96.9346V72.9073C0 72.9073 31.7035 63.3113 57.8122 63.3347C83.9209 63.3555 112 72.8788 112 72.8788V96.9346C112 98.9965 110.329 100.668 108.267 100.668Z"
					fill="#D3D3D3"
				/>
			</g>
			<defs>
				<clipPath id="clip0_5_3661">
					<path
						d="M0 96.9327C0 98.9945 1.67147 100.666 3.73333 100.666H108.267C110.329 100.666 112 98.9945 112 96.9327V0.666016H0V96.9327Z"
						fill="white"
					/>
				</clipPath>
			</defs>
		</chakra.svg>
	)
);

export const BottomSeparator_Curve2 = forwardRef<IconProps, "svg">(
	(props, ref) => (
		<chakra.svg
			width="112"
			height="101"
			viewBox="0 0 112 101"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
			ref={ref}
		>
			<g clipPath="url(#clip0_5_3663)">
				<path
					d="M108.267 100.668H3.73333C1.67147 100.668 0 98.9965 0 96.9346V74.5346L71.8667 65.2013L96.3728 64.0615C104.883 63.6656 112 70.4589 112 78.9787V96.9346C112 98.9965 110.329 100.668 108.267 100.668Z"
					fill="#D3D3D3"
				/>
			</g>
			<defs>
				<clipPath id="clip0_5_3663">
					<path
						d="M0 96.9327C0 98.9945 1.67147 100.666 3.73333 100.666H108.267C110.329 100.666 112 98.9945 112 96.9327V0.666016H0V96.9327Z"
						fill="white"
					/>
				</clipPath>
			</defs>
		</chakra.svg>
	)
);

export const BottomSeparator_Curve3 = forwardRef<IconProps, "svg">(
	(props, ref) => (
		<chakra.svg
			width="112"
			height="101"
			viewBox="0 0 112 101"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
			ref={ref}
		>
			<g clipPath="url(#clip0_5_3665)">
				<path
					d="M0 96.9346C0 98.9965 1.67147 100.668 3.73333 100.668H108.267C110.329 100.668 112 98.9965 112 96.9346V63.3346C112 63.3346 84.4667 79.2759 56.4667 79.4087C28.4667 79.5416 0 63.3346 0 63.3346V96.9346Z"
					fill="#D3D3D3"
				/>
			</g>
			<defs>
				<clipPath id="clip0_5_3665">
					<path
						d="M0 96.9327C0 98.9945 1.67147 100.666 3.73333 100.666H108.267C110.329 100.666 112 98.9945 112 96.9327V0.666016H0V96.9327Z"
						fill="white"
					/>
				</clipPath>
			</defs>
		</chakra.svg>
	)
);

export const BottomSeparator_Rounded1 = forwardRef<IconProps, "svg">(
	(props, ref) => (
		<chakra.svg
			width="112"
			height="101"
			viewBox="0 0 112 101"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
			ref={ref}
		>
			<g clipPath="url(#clip0_5_3667)">
				<path
					d="M108.267 100.668H3.73333C1.67147 100.668 0 98.9965 0 96.9346V74.5346L103.79 64.1556C108.186 63.716 112 67.1678 112 71.5852V96.9346C112 98.9965 110.329 100.668 108.267 100.668Z"
					fill="#D3D3D3"
				/>
			</g>
			<defs>
				<clipPath id="clip0_5_3667">
					<path
						d="M0 96.9327C0 98.9945 1.67147 100.666 3.73333 100.666H108.267C110.329 100.666 112 98.9945 112 96.9327V0.666016H0V96.9327Z"
						fill="white"
					/>
				</clipPath>
			</defs>
		</chakra.svg>
	)
);

export const BottomSeparator_Rounded2 = forwardRef<IconProps, "svg">(
	(props, ref) => (
		<chakra.svg
			width="112"
			height="101"
			viewBox="0 0 112 101"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
			ref={ref}
		>
			<g clipPath="url(#clip0_5_3669)">
				<path
					d="M0 96.9346C0 98.9965 1.67147 100.668 3.73333 100.668H108.267C110.329 100.668 112 98.9965 112 96.9346V67.068C112 65.0061 110.329 63.3346 108.267 63.3346H3.73333C1.67147 63.3346 0 65.0061 0 67.068V96.9346Z"
					fill="#D3D3D3"
				/>
			</g>
			<defs>
				<clipPath id="clip0_5_3669">
					<path
						d="M0 96.9327C0 98.9945 1.67147 100.666 3.73333 100.666H108.267C110.329 100.666 112 98.9945 112 96.9327V0.666016H0V96.9327Z"
						fill="white"
					/>
				</clipPath>
			</defs>
		</chakra.svg>
	)
);

export const BottomSeparator_Rounded3 = forwardRef<IconProps, "svg">(
	(props, ref) => (
		<chakra.svg
			width="112"
			height="101"
			viewBox="0 0 112 101"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
			ref={ref}
		>
			<g clipPath="url(#clip0_5_3671)">
				<path
					d="M108.267 100.668H3.73333C1.67147 100.668 0 98.9965 0 96.9346V75.8228L29.2032 63.9821C30.2539 63.556 31.3879 63.3749 32.519 63.4524L98.9333 68.0013L112 78.268V96.9346C112 98.9965 110.329 100.668 108.267 100.668Z"
					fill="#D3D3D3"
				/>
			</g>
			<defs>
				<clipPath id="clip0_5_3671">
					<path
						d="M0 96.9327C0 98.9945 1.67147 100.666 3.73333 100.666H108.267C110.329 100.666 112 98.9945 112 96.9327V0.666016H0V96.9327Z"
						fill="white"
					/>
				</clipPath>
			</defs>
		</chakra.svg>
	)
);

export const BottomSeparator_Slant1 = forwardRef<IconProps, "svg">(
	(props, ref) => (
		<chakra.svg
			width="112"
			height="101"
			viewBox="0 0 112 101"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
			ref={ref}
		>
			<g clipPath="url(#clip0_5_3657)">
				<path
					d="M108.267 100.668H3.73333C1.67147 100.668 0 98.9965 0 96.9346V78.268L112 63.3346V96.9346C112 98.9965 110.329 100.668 108.267 100.668Z"
					fill="#D3D3D3"
				/>
			</g>
			<defs>
				<clipPath id="clip0_5_3657">
					<path
						d="M0 96.9327C0 98.9945 1.67147 100.666 3.73333 100.666H108.267C110.329 100.666 112 98.9945 112 96.9327V0.666016H0V96.9327Z"
						fill="white"
					/>
				</clipPath>
			</defs>
		</chakra.svg>
	)
);

export const BottomSeparator_Slant2 = forwardRef<IconProps, "svg">(
	(props, ref) => (
		<chakra.svg
			width="112"
			height="101"
			viewBox="0 0 112 101"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
			ref={ref}
		>
			<g clipPath="url(#clip0_5_3659)">
				<path
					d="M0 63.334L56 77.334L112 63.334V96.934C112 98.9958 110.329 100.667 108.267 100.667H3.73333C1.67147 100.667 0 98.9958 0 96.934V63.334Z"
					fill="#D3D3D3"
				/>
			</g>
			<defs>
				<clipPath id="clip0_5_3659">
					<path
						d="M0 96.9327C0 98.9945 1.67147 100.666 3.73333 100.666H108.267C110.329 100.666 112 98.9945 112 96.9327V0.666016H0V96.9327Z"
						fill="white"
					/>
				</clipPath>
			</defs>
		</chakra.svg>
	)
);

export const BottomSeparator_Straight = forwardRef<IconProps, "svg">(
	(props, ref) => (
		<chakra.svg
			width="112"
			height="101"
			viewBox="0 0 112 101"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
			ref={ref}
		>
			<g clipPath="url(#clip0_5_3673)">
				<path
					d="M0 96.9346C0 98.9965 1.67147 100.668 3.73333 100.668H108.267C110.329 100.668 112 98.9965 112 96.9346V63.3346H0V96.9346Z"
					fill="#D3D3D3"
				/>
			</g>
			<defs>
				<clipPath id="clip0_5_3673">
					<path
						d="M0 96.9327C0 98.9945 1.67147 100.666 3.73333 100.666H108.267C110.329 100.666 112 98.9945 112 96.9327V0.666016H0V96.9327Z"
						fill="white"
					/>
				</clipPath>
			</defs>
		</chakra.svg>
	)
);

export const BottomSeparator_Wave1 = forwardRef<IconProps, "svg">(
	(props, ref) => (
		<chakra.svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 112 100"
			{...props}
			ref={ref}
		>
			<g clipPath="url(#clip0_5_3649)">
				<path
					d="M0 96.934V65.1894C5.78667 68.0022 10.9479 72.9018 21.84 68.0022C34.3467 62.3764 44.8 64.8932 54.32 70.371C63.0933 75.4192 69.8133 72.5918 74.2933 70.371C90.5333 59.8596 101.36 62.4706 112 69.4289V96.934C112 98.9958 110.329 100.667 108.267 100.667H3.73333C1.67147 100.667 0 98.9958 0 96.934Z"
					fill="#D3D3D3"
				/>
			</g>
			<defs>
				<clipPath id="clip0_5_3649">
					<path
						d="M0 96.9327C0 98.9945 1.67147 100.666 3.73333 100.666H108.267C110.329 100.666 112 98.9945 112 96.9327V0.666016H0V96.9327Z"
						fill="white"
					/>
				</clipPath>
			</defs>
		</chakra.svg>
	)
);

export const BottomSeparator_Wave2 = forwardRef<IconProps, "svg">(
	(props, ref) => (
		<chakra.svg
			width="112"
			height="101"
			viewBox="0 0 112 101"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
			ref={ref}
		>
			<g clipPath="url(#clip0_5_3651)">
				<path
					d="M108.267 100.668H3.73333C1.67147 100.668 0 98.9965 0 96.9346V83.9328V67.2799C3.52352 69.121 6.91973 66.6652 8.70086 65.7931C17.893 61.2924 24.0662 64.0084 27.0281 65.7931C33.2606 69.9897 40.1967 76.6782 58.6843 71.1473C73.6793 66.6614 82.5255 64.5781 96.8198 73.1733C104.04 77.5145 105.706 76.9357 112 75.1992V96.9346C112 98.9965 110.329 100.668 108.267 100.668Z"
					fill="#D3D3D3"
				/>
			</g>
			<defs>
				<clipPath id="clip0_5_3651">
					<path
						d="M0 96.9327C0 98.9945 1.67147 100.666 3.73333 100.666H108.267C110.329 100.666 112 98.9945 112 96.9327V0.666016H0V96.9327Z"
						fill="white"
					/>
				</clipPath>
			</defs>
		</chakra.svg>
	)
);

export const BottomSeparator_Wave3 = forwardRef<IconProps, "svg">(
	(props, ref) => (
		<chakra.svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 120 100"
			{...props}
			ref={ref}
		>
			<path
				d="M0 76.4821V95.9531C0 98.5571 2.11091 100.668 4.71485 100.668H107.285C109.889 100.668 112 98.5571 112 95.9531V76.4721C102.2 80.8462 88.2 79.3532 81.9665 76.4721C47.2177 60.4115 35.9333 57.5539 0 76.4821Z"
				fill="#D3D3D3"
			/>
		</chakra.svg>
	)
);

export const BottomSeparator_Wave4 = forwardRef<IconProps, "svg">(
	(props, ref) => (
		<chakra.svg
			width="112"
			height="101"
			viewBox="0 0 112 101"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
			ref={ref}
		>
			<g clipPath="url(#clip0_5_3655)">
				<path
					d="M0 96.934V63.6754C8.86667 69.2038 10.2667 65.5339 25.6667 63.4677C31.6072 62.6707 35.5311 65.5502 39.4351 69.0695C40.7843 70.2857 42.5677 70.9032 44.3818 70.8095C56.4399 70.1871 56.5093 72.6448 63.4667 76.7324C68.4537 79.6624 71.8667 79.6004 75.1333 78.1664C98.4667 68.8453 106.4 71.987 112 74.8551V96.934C112 98.9958 110.329 100.667 108.267 100.667H3.73333C1.67147 100.667 0 98.9958 0 96.934Z"
					fill="#D3D3D3"
				/>
			</g>
			<defs>
				<clipPath id="clip0_5_3655">
					<path
						d="M0 96.9327C0 98.9945 1.67147 100.666 3.73333 100.666H108.267C110.329 100.666 112 98.9945 112 96.9327V0.666016H0V96.9327Z"
						fill="white"
					/>
				</clipPath>
			</defs>
		</chakra.svg>
	)
);

export const Seperator_None = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 112 122"
		fill="#E0E0E0 !important"
		{...props}
		ref={ref}
	>
		<rect width="111" height="121" x=".5" y=".5" fill="#F4F4F4" rx="1.5" />
		<rect
			width="111"
			height="121"
			x=".5"
			y=".5"
			stroke="#E0E0E0"
			rx="1.5"
		/>
		<path
			fill="#222"
			// eslint-disable-next-line max-len
			d="M46.342 66h-1.65l-4.348-6.69a2.96 2.96 0 0 1-.273-.527h-.038c.034.194.05.611.05 1.25V66h-1.46v-9.102h1.759l4.202 6.531c.178.271.292.457.343.559h.025c-.042-.241-.063-.65-.063-1.225v-5.865h1.453V66Zm6.011.152c-1.311 0-2.363-.425-3.154-1.276-.787-.85-1.18-1.957-1.18-3.32 0-1.464.401-2.631 1.205-3.503.804-.872 1.896-1.308 3.276-1.308 1.278 0 2.306.423 3.084 1.27.783.846 1.175 1.953 1.175 3.32 0 1.485-.4 2.66-1.2 3.522-.8.864-1.868 1.295-3.206 1.295Zm.07-8.08c-.833 0-1.513.31-2.037.933-.52.622-.781 1.44-.781 2.456 0 1.012.254 1.826.762 2.444.508.618 1.172.927 1.993.927.872 0 1.56-.294 2.063-.882.503-.589.755-1.412.755-2.47 0-1.087-.245-1.927-.736-2.52-.487-.592-1.16-.888-2.019-.888ZM66.147 66h-1.65l-4.349-6.69a2.966 2.966 0 0 1-.273-.527h-.038c.034.194.051.611.051 1.25V66h-1.46v-9.102h1.759l4.202 6.531c.177.271.292.457.342.559h.026c-.043-.241-.064-.65-.064-1.225v-5.865h1.454V66Zm7.37 0h-5.11v-9.102h4.907v1.282h-3.396v2.577h3.129v1.276h-3.13v2.691h3.6V66Z"
		/>
	</chakra.svg>
));

export const TopSeparator_Curve1 = forwardRef<IconProps, "svg">(
	(props, ref) => (
		<chakra.svg
			width="112"
			height="101"
			viewBox="0 0 112 101"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
			ref={ref}
		>
			<g clipPath="url(#clip0_5_3567)">
				<path
					d="M108.267 0.332031H3.73333C1.67147 0.332031 0 2.0035 0 4.06537V28.0927C0 28.0927 31.7035 37.6887 57.8122 37.6653C83.9209 37.6445 112 28.1212 112 28.1212V4.06536C112 2.0035 110.329 0.332031 108.267 0.332031Z"
					fill="#D3D3D3"
				/>
			</g>
			<defs>
				<clipPath id="clip0_5_3567">
					<path
						d="M0 4.06732C0 2.00545 1.67147 0.333984 3.73333 0.333984H108.267C110.329 0.333984 112 2.00545 112 4.06732V100.334H0V4.06732Z"
						fill="white"
					/>
				</clipPath>
			</defs>
		</chakra.svg>
	)
);

export const TopSeparator_Curve2 = forwardRef<IconProps, "svg">(
	(props, ref) => (
		<chakra.svg
			width="112"
			height="101"
			viewBox="0 0 112 101"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
			ref={ref}
		>
			<g clipPath="url(#clip0_5_3569)">
				<path
					d="M108.267 0.332031H3.73333C1.67147 0.332031 0 2.0035 0 4.06536V26.4654L71.8667 35.7987L96.3728 36.9385C104.883 37.3344 112 30.5411 112 22.0213V4.06536C112 2.0035 110.329 0.332031 108.267 0.332031Z"
					fill="#D3D3D3"
				/>
			</g>
			<defs>
				<clipPath id="clip0_5_3569">
					<path
						d="M0 4.06732C0 2.00545 1.67147 0.333984 3.73333 0.333984H108.267C110.329 0.333984 112 2.00545 112 4.06732V100.334H0V4.06732Z"
						fill="white"
					/>
				</clipPath>
			</defs>
		</chakra.svg>
	)
);

export const TopSeparator_Curve3 = forwardRef<IconProps, "svg">(
	(props, ref) => (
		<chakra.svg
			width="112"
			height="101"
			viewBox="0 0 112 101"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
			ref={ref}
		>
			<g clipPath="url(#clip0_5_3571)">
				<path
					d="M0 4.06536C0 2.0035 1.67147 0.332031 3.73333 0.332031H108.267C110.329 0.332031 112 2.0035 112 4.06536V37.6654C112 37.6654 84.4667 21.7241 56.4667 21.5913C28.4667 21.4584 0 37.6654 0 37.6654V4.06536Z"
					fill="#D3D3D3"
				/>
			</g>
			<defs>
				<clipPath id="clip0_5_3571">
					<path
						d="M0 4.06732C0 2.00545 1.67147 0.333984 3.73333 0.333984H108.267C110.329 0.333984 112 2.00545 112 4.06732V100.334H0V4.06732Z"
						fill="white"
					/>
				</clipPath>
			</defs>
		</chakra.svg>
	)
);

export const TopSeparator_Rounded1 = forwardRef<IconProps, "svg">(
	(props, ref) => (
		<chakra.svg
			width="112"
			height="101"
			viewBox="0 0 112 101"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
			ref={ref}
		>
			<g clipPath="url(#clip0_5_3573)">
				<path
					d="M108.267 0.332031H3.73333C1.67147 0.332031 0 2.0035 0 4.06536V26.4654L103.79 36.8444C108.186 37.284 112 33.8322 112 29.4148V4.06536C112 2.0035 110.329 0.332031 108.267 0.332031Z"
					fill="#D3D3D3"
				/>
			</g>
			<defs>
				<clipPath id="clip0_5_3573">
					<path
						d="M0 4.06732C0 2.00545 1.67147 0.333984 3.73333 0.333984H108.267C110.329 0.333984 112 2.00545 112 4.06732V100.334H0V4.06732Z"
						fill="white"
					/>
				</clipPath>
			</defs>
		</chakra.svg>
	)
);

export const TopSeparator_Rounded2 = forwardRef<IconProps, "svg">(
	(props, ref) => (
		<chakra.svg
			width="112"
			height="101"
			viewBox="0 0 112 101"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
			ref={ref}
		>
			<path
				d="M0 4.06536C0 2.0035 1.67147 0.332031 3.73333 0.332031H108.267C110.329 0.332031 112 2.0035 112 4.06536V33.932C112 35.9939 110.329 37.6654 108.267 37.6654H3.73333C1.67147 37.6654 0 35.9939 0 33.932V4.06536Z"
				fill="#D3D3D3"
			/>
		</chakra.svg>
	)
);

export const TopSeparator_Rounded3 = forwardRef<IconProps, "svg">(
	(props, ref) => (
		<chakra.svg
			width="112"
			height="101"
			viewBox="0 0 112 101"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
			ref={ref}
		>
			<g clipPath="url(#clip0_5_3577)">
				<path
					d="M108.267 0.332031H3.73333C1.67147 0.332031 0 2.00351 0 4.06537V25.1772L29.2032 37.0179C30.2539 37.444 31.3879 37.6251 32.519 37.5476L98.9333 32.9987L112 22.732V4.06536C112 2.0035 110.329 0.332031 108.267 0.332031Z"
					fill="#D3D3D3"
				/>
			</g>
			<defs>
				<clipPath id="clip0_5_3577">
					<path
						d="M0 4.06732C0 2.00545 1.67147 0.333984 3.73333 0.333984H108.267C110.329 0.333984 112 2.00545 112 4.06732V100.334H0V4.06732Z"
						fill="white"
					/>
				</clipPath>
			</defs>
		</chakra.svg>
	)
);

export const TopSeparator_Slant1 = forwardRef<IconProps, "svg">(
	(props, ref) => (
		<chakra.svg
			width="112"
			height="101"
			viewBox="0 0 112 101"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
			ref={ref}
		>
			<g clipPath="url(#clip0_5_3563)">
				<path
					d="M108.267 0.332031H3.73333C1.67147 0.332031 0 2.0035 0 4.06536V22.732L112 37.6654V4.06536C112 2.0035 110.329 0.332031 108.267 0.332031Z"
					fill="#D3D3D3"
				/>
			</g>
			<defs>
				<clipPath id="clip0_5_3563">
					<path
						d="M0 4.06732C0 2.00545 1.67147 0.333984 3.73333 0.333984H108.267C110.329 0.333984 112 2.00545 112 4.06732V100.334H0V4.06732Z"
						fill="white"
					/>
				</clipPath>
			</defs>
		</chakra.svg>
	)
);

export const TopSeparator_Slant2 = forwardRef<IconProps, "svg">(
	(props, ref) => (
		<chakra.svg
			width="112"
			height="101"
			viewBox="0 0 112 101"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
			ref={ref}
		>
			<g clipPath="url(#clip0_5_3565)">
				<path
					d="M0 37.666L56 23.666L112 37.666V4.06601C112 2.00415 110.329 0.332685 108.267 0.332685H3.73333C1.67147 0.332685 0 2.00415 0 4.06602V37.666Z"
					fill="#D3D3D3"
				/>
			</g>
			<defs>
				<clipPath id="clip0_5_3565">
					<path
						d="M0 4.06732C0 2.00545 1.67147 0.333984 3.73333 0.333984H108.267C110.329 0.333984 112 2.00545 112 4.06732V100.334H0V4.06732Z"
						fill="white"
					/>
				</clipPath>
			</defs>
		</chakra.svg>
	)
);

export const TopSeparator_Straight = forwardRef<IconProps, "svg">(
	(props, ref) => (
		<chakra.svg
			width="112"
			height="101"
			viewBox="0 0 112 101"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
			ref={ref}
		>
			<g clipPath="url(#clip0_5_3579)">
				<path
					d="M0 4.06536C0 2.0035 1.67147 0.332031 3.73333 0.332031H108.267C110.329 0.332031 112 2.0035 112 4.06536V37.6654H0V4.06536Z"
					fill="#D3D3D3"
				/>
			</g>
			<defs>
				<clipPath id="clip0_5_3579">
					<path
						d="M0 4.06732C0 2.00545 1.67147 0.333984 3.73333 0.333984H108.267C110.329 0.333984 112 2.00545 112 4.06732V100.334H0V4.06732Z"
						fill="white"
					/>
				</clipPath>
			</defs>
		</chakra.svg>
	)
);

export const TopSeparator_Wave1 = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 112 100"
		{...props}
		ref={ref}
	>
		<path
			fill="#D3D3D3"
			d="M0 3.733v31.428c5.787-2.788 10.948-7.643 21.84-2.788 12.507 5.576 22.96 3.082 32.48-2.347 8.773-5.003 15.493-2.201 19.973 0 16.24 10.417 27.067 7.83 37.707.933V3.733A3.733 3.733 0 0 0 108.267 0H3.733A3.733 3.733 0 0 0 0 3.733Z"
		/>
	</chakra.svg>
));

export const TopSeparator_Wave2 = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		width="112"
		height="101"
		viewBox="0 0 112 101"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
		ref={ref}
	>
		<g clipPath="url(#clip0_5_3557)">
			<path
				d="M108.267 0.332031H3.73333C1.67147 0.332031 0 2.0035 0 4.06536V17.0672V33.7201C3.52352 31.879 6.91973 34.3348 8.70086 35.2069C17.893 39.7076 24.0662 36.9916 27.0281 35.2069C33.2606 31.0103 40.1967 24.3218 58.6843 29.8527C73.6793 34.3386 82.5255 36.4219 96.8198 27.8267C104.04 23.4855 105.706 24.0643 112 25.8008V4.06536C112 2.0035 110.329 0.332031 108.267 0.332031Z"
				fill="#D3D3D3"
			/>
		</g>
		<defs>
			<clipPath id="clip0_5_3557">
				<path
					d="M0 4.06732C0 2.00545 1.67147 0.333984 3.73333 0.333984H108.267C110.329 0.333984 112 2.00545 112 4.06732V100.334H0V4.06732Z"
					fill="white"
				/>
			</clipPath>
		</defs>
	</chakra.svg>
));

export const TopSeparator_Wave3 = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 120 100"
		{...props}
		ref={ref}
	>
		<path
			fill="#D3D3D3"
			d="M0 25.913V5.052A5.052 5.052 0 0 1 5.052 0h109.896A5.052 5.052 0 0 1 120 5.052v20.872c-10.5-4.686-25.5-3.087-32.179 0C50.591 43.132 38.5 46.194 0 25.914Z"
		/>
	</chakra.svg>
));

export const TopSeparator_Wave4 = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		width="112"
		height="101"
		viewBox="0 0 112 101"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
		ref={ref}
	>
		<g clipPath="url(#clip0_5_3561)">
			<path
				d="M0 4.06601V37.3246C8.86667 31.7962 10.2667 35.4661 25.6667 37.5323C31.6072 38.3293 35.5311 35.4498 39.4351 31.9305C40.7843 30.7143 42.5677 30.0968 44.3818 30.1905C56.4399 30.8129 56.5093 28.3552 63.4667 24.2676C68.4537 21.3376 71.8667 21.3996 75.1333 22.8336C98.4667 32.1547 106.4 29.013 112 26.1449V4.06602C112 2.00415 110.329 0.332684 108.267 0.332684H3.73333C1.67147 0.332684 0 2.00415 0 4.06601Z"
				fill="#D3D3D3"
			/>
		</g>
		<defs>
			<clipPath id="clip0_5_3561">
				<path
					d="M0 4.06732C0 2.00545 1.67147 0.333984 3.73333 0.333984H108.267C110.329 0.333984 112 2.00545 112 4.06732V100.334H0V4.06732Z"
					fill="white"
				/>
			</clipPath>
		</defs>
	</chakra.svg>
));

export const ButtonPlain = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		viewBox="0 0 48 12"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
		ref={ref}
	>
		<path d="M0 6c0-.552.768-1 1.714-1h44.572C47.233 5 48 5.448 48 6s-.767 1-1.714 1H1.714C.768 7 0 6.552 0 6Z"></path>
	</chakra.svg>
));

export const ButtonFilled = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		viewBox="0 0 48 20"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
		ref={ref}
	>
		<path
			fillRule="evenodd"
			d="M3.429 0C1.535 0 0 1.473 0 3.29v13.42C0 18.527 1.535 20 3.429 20H44.57c1.895 0 3.43-1.473 3.43-3.29V3.29C48 1.472 46.465 0 44.571 0H3.43Zm4.21 9.868c-.432 0-.782.336-.782.75 0 .415.35.75.782.75h32.036c.432 0 .782-.335.782-.75 0-.414-.35-.75-.782-.75H7.64Z"
			clipRule="evenodd"
		></path>
	</chakra.svg>
));

export const ButtonOutline = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		viewBox="0 0 48 24"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
		ref={ref}
	>
		<path
			fillRule="evenodd"
			d="M44.571 1.645H3.43c-.947 0-1.715.736-1.715 1.645v13.42c0 .909.768 1.645 1.715 1.645h41.14c.947 0 1.715-.736 1.715-1.645V3.29c0-.909-.768-1.645-1.715-1.645ZM3.43 0C1.535 0 0 1.473 0 3.29v13.42C0 18.527 1.535 20 3.429 20H44.57c1.895 0 3.43-1.473 3.43-3.29V3.29C48 1.473 46.465 0 44.571 0H3.43Z"
			clipRule="evenodd"
		></path>
		<path d="M7.2 10.25c0-.414.35-.75.782-.75h32.037c.431 0 .781.336.781.75s-.35.75-.781.75H7.982c-.432 0-.782-.336-.782-.75Z"></path>
		<path
			fillRule="evenodd"
			d="M40.019 11c.431 0 .781-.336.781-.75s-.35-.75-.781-.75H7.982c-.432 0-.782.336-.782.75s.35.75.782.75h32.037Z"
			clipRule="evenodd"
		></path>
	</chakra.svg>
));

export const ButtonLink = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		viewBox="0 0 48 12"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
		ref={ref}
	>
		<path d="M0 4.5c0-.552.768-1 1.714-1h44.572c.947 0 1.714.448 1.714 1s-.767 1-1.714 1H1.714C.768 5.5 0 5.052 0 4.5ZM0 8c0-.276.384-.5.857-.5h46.286c.473 0 .857.224.857.5s-.384.5-.857.5H.857C.384 8.5 0 8.276 0 8Z"></path>
	</chakra.svg>
));

export const Modal = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
		ref={ref}
	>
		<path d="M7.62 13.89c0-.46.38-.84.84-.84h7.92c.46 0 .84.38.84.84s-.38.84-.84.84H8.46c-.47 0-.84-.37-.84-.84zm0 3.36c0-.46.38-.84.84-.84h7.92c.46 0 .84.38.84.84s-.38.84-.84.84H8.46c-.47 0-.84-.37-.84-.84zm10.68-7.11c.28-.28.28-.74 0-1.02l-.95-.95.95-.95c.29-.28.3-.73.02-1.02a.715.715 0 0 0-1.02-.02l-.02.02-.95.95-.95-.95a.724.724 0 0 0-1.02 0c-.28.28-.28.74 0 1.02l.95.95-.95.95c-.28.28-.28.74 0 1.02s.74.28 1.02 0l.95-.95.95.95c.29.29.74.29 1.02 0z" />
		<path
			d="M2.34 4.89a2.88 2.88 0 0 1 2.88-2.88h14.4a2.88 2.88 0 0 1 2.88 2.88v14.4a2.88 2.88 0 0 1-2.88 2.88H5.22a2.88 2.88 0 0 1-2.88-2.88V4.89zm2.88-.87h14.4c.49 0 .88.39.88.88v14.4c0 .48-.39.88-.88.88H5.22c-.48 0-.88-.39-.88-.88V4.89c0-.48.39-.87.88-.87z"
			fillRule="evenodd"
			clipRule="evenodd"
		/>
	</chakra.svg>
));

export const BannerPostLayout3Style1 = forwardRef<IconProps, "svg">(
	(props, ref) => (
		<chakra.svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 240 104"
			{...props}
		>
			<path
				fill="#BDBDBD"
				d="M118 22H82v56.95h36V22Zm40 0h-36v56.95h36V22Z"
			/>
		</chakra.svg>
	)
);

export const BannerPostLayout3Style2 = forwardRef<IconProps, "svg">(
	(props, ref) => (
		<chakra.svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 240 104"
			{...props}
		>
			<path fill="#BDBDBD" d="M82 22h42v57H82zm46 0h30v57h-30z" />
		</chakra.svg>
	)
);

export const BannerPostLayout3Style3 = forwardRef<IconProps, "svg">(
	(props, ref) => (
		<chakra.svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 240 104"
			{...props}
		>
			<path
				fill="#BDBDBD"
				d="M82 22.05h49V79H82V22.05Zm52.667 0H158V79h-23.333V22.05Z"
			/>
		</chakra.svg>
	)
);

export const BannerPostLayout4Style1 = forwardRef<IconProps, "svg">(
	(props, ref) => (
		<chakra.svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 240 104"
			{...props}
		>
			<path fill="#BDBDBD" d="M61 25h30v25H61V25Zm0 29h30v25H61V54Z" />
			<path
				fill="#fff"
				d="M65 41a1 1 0 0 1 1-1h20a1 1 0 1 1 0 2H66a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H66a1 1 0 0 1-1-1Zm0 25a1 1 0 0 1 1-1h20a1 1 0 1 1 0 2H66a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H66a1 1 0 0 1-1-1Z"
			/>
			<path
				fill="#BDBDBD"
				d="M95 25h50v54H95V25Zm54 0h30v25h-30V25Zm0 29h30v25h-30V54Z"
			/>
			<path
				fill="#fff"
				d="M153 41a1 1 0 0 1 1-1h20a1 1 0 0 1 0 2h-20a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h12a1 1 0 0 1 0 2h-12a1 1 0 0 1-1-1Zm0 25a1 1 0 0 1 1-1h20a1 1 0 0 1 0 2h-20a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h12a1 1 0 0 1 0 2h-12a1 1 0 0 1-1-1Zm-54-8.75c0-.69.56-1.25 1.25-1.25h39.5a1.25 1.25 0 0 1 0 2.5h-39.5c-.69 0-1.25-.56-1.25-1.25Zm0 4.25a1 1 0 0 1 1-1h31a1 1 0 0 1 0 2h-31a1 1 0 0 1-1-1Zm0 4.25c0-.69.56-1.25 1.25-1.25h10.5a1.25 1.25 0 0 1 0 2.5h-10.5c-.69 0-1.25-.56-1.25-1.25Z"
			/>
		</chakra.svg>
	)
);

export const BannerPostLayout4Style2 = forwardRef<IconProps, "svg">(
	(props, ref) => (
		<chakra.svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 240 104"
			{...props}
		>
			<path fill="#BDBDBD" d="M72 20h63v34H72V20Z" />
			<path
				fill="#fff"
				d="M76 45a1 1 0 0 1 1-1h53a1 1 0 0 1 0 2H77a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h26a1 1 0 0 1 0 2H77a1 1 0 0 1-1-1Z"
			/>
			<path fill="#BDBDBD" d="M139 20h29v34h-29V20Z" />
			<path
				fill="#fff"
				d="M143 45a1 1 0 0 1 1-1h19a1 1 0 0 1 0 2h-19a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h11a1 1 0 0 1 0 2h-11a1 1 0 0 1-1-1Z"
			/>
			<path
				fill="#BDBDBD"
				d="M72 58h29.333v26H72V58Zm33.333 0h29.334v26h-29.334V58Zm33.334 0H168v26h-29.333V58Z"
			/>
			<path
				fill="#fff"
				d="M76 75a1 1 0 0 1 1-1h19a1 1 0 1 1 0 2H77a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H77a1 1 0 0 1-1-1Zm33-4a1 1 0 0 1 1-1h19a1 1 0 0 1 0 2h-19a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h10a1 1 0 0 1 0 2h-10a1 1 0 0 1-1-1Zm34-4a1 1 0 0 1 1-1h19a1 1 0 0 1 0 2h-19a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h10a1 1 0 0 1 0 2h-10a1 1 0 0 1-1-1Z"
			/>
		</chakra.svg>
	)
);

export const BannerPostLayout5Style1 = forwardRef<IconProps, "svg">(
	(props, ref) => (
		<chakra.svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 240 104"
			{...props}
		>
			<path fill="#BDBDBD" d="M67 25h47v54H67V25Z" />
			<path
				fill="#fff"
				d="M72 64.25c0-.69.56-1.25 1.25-1.25h34.5a1.25 1.25 0 0 1 0 2.5h-34.5c-.69 0-1.25-.56-1.25-1.25Zm0 4.25a1 1 0 0 1 1-1h31a1 1 0 0 1 0 2H73a1 1 0 0 1-1-1Zm0 4.25c0-.69.56-1.25 1.25-1.25h10.5a1.25 1.25 0 1 1 0 2.5h-10.5c-.69 0-1.25-.56-1.25-1.25Z"
			/>
			<path
				fill="#BDBDBD"
				d="M118 25h25.5v26H118V25Zm29.5 0H173v26h-25.5V25Z"
			/>
			<path
				fill="#fff"
				d="M122 42a1 1 0 0 1 1-1h15a1 1 0 0 1 0 2h-15a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h9a1 1 0 0 1 0 2h-9a1 1 0 0 1-1-1Zm30-4a1 1 0 0 1 1-1h15a1 1 0 0 1 0 2h-15a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h9a1 1 0 0 1 0 2h-9a1 1 0 0 1-1-1Z"
			/>
			<path fill="#BDBDBD" d="M118 55h55v24h-55V55Z" />
			<path
				fill="#fff"
				d="M122 70a1 1 0 0 1 1-1h45a1 1 0 0 1 0 2h-45a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h13a1 1 0 0 1 0 2h-13a1 1 0 0 1-1-1Z"
			/>
		</chakra.svg>
	)
);

export const BannerPostLayout5Style2 = forwardRef<IconProps, "svg">(
	(props, ref) => (
		<chakra.svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 240 104"
			{...props}
		>
			<path fill="#BDBDBD" d="M61 15.5h118v54H61v-54Z" />
			<path
				fill="#fff"
				d="M67 43.75c0-.69.56-1.25 1.25-1.25h39.5a1.25 1.25 0 0 1 0 2.5h-39.5c-.69 0-1.25-.56-1.25-1.25ZM67 48a1 1 0 0 1 1-1h31a1 1 0 1 1 0 2H68a1 1 0 0 1-1-1Zm0 4.25c0-.69.56-1.25 1.25-1.25h10.5a1.25 1.25 0 1 1 0 2.5h-10.5c-.69 0-1.25-.56-1.25-1.25Z"
			/>
			<path fill="#BDBDBD" d="M75 61.5h30v25H75v-25Z" />
			<path fill="#fff" d="M105 61.5H75v25h30v-25Zm2 27H73v-29h34v29Z" />
			<path
				fill="#fff"
				d="M79 77.5a1 1 0 0 1 1-1h20a1 1 0 0 1 0 2H80a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h12a1 1 0 0 1 0 2H80a1 1 0 0 1-1-1Z"
			/>
			<path fill="#BDBDBD" d="M135 61.5h30v25h-30v-25Z" />
			<path
				fill="#fff"
				d="M165 61.5h-30v25h30v-25Zm2 27h-34v-29h34v29Z"
			/>
			<path
				fill="#fff"
				d="M139 77.5a1 1 0 0 1 1-1h20a1 1 0 0 1 0 2h-20a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h12a1 1 0 0 1 0 2h-12a1 1 0 0 1-1-1Z"
			/>
			<path fill="#BDBDBD" d="M105 61.5h30v25h-30v-25Z" />
			<path
				fill="#fff"
				d="M135 61.5h-30v25h30v-25Zm2 27h-34v-29h34v29Z"
			/>
			<path
				fill="#fff"
				d="M109 77.5a1 1 0 0 1 1-1h20a1 1 0 0 1 0 2h-20a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h12a1 1 0 0 1 0 2h-12a1 1 0 0 1-1-1Z"
			/>
		</chakra.svg>
	)
);

export const FeaturedCategoriesLayout1 = forwardRef<IconProps, "svg">(
	(props, ref) => (
		<chakra.svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 240 104"
			{...props}
		>
			<path
				fill="#BDBDBD"
				d="M74 25h44v21.5H74V25Zm0 25.75c0-.69.985-1.25 2.2-1.25h39.6c1.215 0 2.2.56 2.2 1.25s-.985 1.25-2.2 1.25H76.2c-1.215 0-2.2-.56-2.2-1.25ZM74 55a1 1 0 0 1 1-1h11a1 1 0 1 1 0 2H75a1 1 0 0 1-1-1Zm48-30h44v21.5h-44V25Zm0 25.75c0-.69.985-1.25 2.2-1.25h39.6c1.215 0 2.2.56 2.2 1.25s-.985 1.25-2.2 1.25h-39.6c-1.215 0-2.2-.56-2.2-1.25Zm0 4.25a1 1 0 0 1 1-1h11a1 1 0 0 1 0 2h-11a1 1 0 0 1-1-1Zm-48 5h20v10H74V60Zm0 14a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H75a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h11a1 1 0 1 1 0 2H75a1 1 0 0 1-1-1Zm24-18h20v10H98V60Zm0 14a1 1 0 0 1 1-1h18a1 1 0 0 1 0 2H99a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h11a1 1 0 0 1 0 2H99a1 1 0 0 1-1-1Zm24-18h20v10h-20V60Zm0 14a1 1 0 0 1 1-1h18a1 1 0 0 1 0 2h-18a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h11a1 1 0 0 1 0 2h-11a1 1 0 0 1-1-1Zm24-18h20v10h-20V60Zm0 14a1 1 0 0 1 1-1h18a1 1 0 0 1 0 2h-18a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h11a1 1 0 0 1 0 2h-11a1 1 0 0 1-1-1Z"
			/>
		</chakra.svg>
	)
);

export const Icon1 = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 112 100"
		fill="none"
		{...props}
		ref={ref}
	>
		<path
			fill="#BDBDBD"
			fillRule="evenodd"
			d="M56 60.08c5.567 0 10.08-4.513 10.08-10.08S61.567 39.92 56 39.92 45.92 44.433 45.92 50 50.433 60.08 56 60.08Zm2.856-5.102a.56.56 0 0 0 .257.062.56.56 0 0 0 .348-.1.56.56 0 0 0 .224-.56l-.56-3.154 2.307-2.24a.56.56 0 0 0 .14-.56.56.56 0 0 0-.454-.38l-3.192-.465-1.422-2.867a.56.56 0 0 0-1.008 0l-1.406 2.872-3.192.465a.56.56 0 0 0-.453.38.56.56 0 0 0 .14.56l2.307 2.24-.56 3.154a.56.56 0 0 0 .812.593L56 53.483l2.856 1.495Z"
			clipRule="evenodd"
		/>
	</chakra.svg>
));

export const Icon2 = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 112 100"
		fill="none"
		{...props}
		ref={ref}
	>
		<path
			fill="#BDBDBD"
			d="M58.856 54.978a.56.56 0 0 0 .257.062.56.56 0 0 0 .348-.1.56.56 0 0 0 .224-.56l-.56-3.154 2.307-2.24a.56.56 0 0 0 .14-.56.56.56 0 0 0-.454-.38l-3.192-.465-1.422-2.867a.56.56 0 0 0-1.008 0l-1.406 2.872-3.192.465a.56.56 0 0 0-.453.38.56.56 0 0 0 .14.56l2.307 2.24-.56 3.154a.56.56 0 0 0 .812.593L56 53.483l2.856 1.495Z"
		/>
		<path
			fill="#BDBDBD"
			fillRule="evenodd"
			d="M66.08 50c0 5.567-4.513 10.08-10.08 10.08S45.92 55.567 45.92 50 50.433 39.92 56 39.92 66.08 44.433 66.08 50Zm-.56 0a9.52 9.52 0 1 1-19.04 0 9.52 9.52 0 0 1 19.04 0Z"
			clipRule="evenodd"
		/>
	</chakra.svg>
));

export const Icon3 = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 112 100"
		fill="none"
		{...props}
		ref={ref}
	>
		<path
			fill="#BDBDBD"
			xmlns="http://www.w3.org/2000/svg"
			fillRule="evenodd"
			d="M65.8 40.2H46.2v19.6h19.6V40.2Zm-7.023 14.64c.077.04.163.06.25.06a.545.545 0 0 0 .338-.098.545.545 0 0 0 .218-.544l-.545-3.066 2.243-2.177a.544.544 0 0 0 .136-.545.544.544 0 0 0-.44-.37l-3.104-.452-1.383-2.787a.545.545 0 0 0-.98 0l-1.366 2.793-3.104.451a.545.545 0 0 0-.44.37.544.544 0 0 0 .135.545l2.243 2.178-.544 3.065a.543.543 0 0 0 .79.577L56 53.387l2.777 1.453Z"
			clipRule="evenodd"
		/>
	</chakra.svg>
));

export const Icon4 = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 112 100"
		fill="none"
		{...props}
		ref={ref}
	>
		<path
			fill="#BDBDBD"
			d="M58.777 54.84c.077.04.163.06.25.06a.545.545 0 0 0 .338-.098.545.545 0 0 0 .218-.544l-.545-3.066 2.243-2.177a.544.544 0 0 0 .136-.545.544.544 0 0 0-.44-.37l-3.104-.452-1.383-2.787a.545.545 0 0 0-.98 0l-1.366 2.793-3.104.451a.545.545 0 0 0-.44.37.544.544 0 0 0 .135.545l2.243 2.178-.544 3.065a.543.543 0 0 0 .79.577L56 53.387l2.777 1.453Z"
		/>
		<path
			fill="#BDBDBD"
			fillRule="evenodd"
			d="M46.2 40.2h19.6v19.6H46.2V40.2Zm.545.545h18.51v18.51h-18.51v-18.51Z"
			clipRule="evenodd"
		/>
	</chakra.svg>
));

export const Icon5 = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 112 100"
		fill="none"
		{...props}
		ref={ref}
	>
		<path
			fill="#BDBDBD"
			xmlns="http://www.w3.org/2000/svg"
			fillRule="evenodd"
			d="M48.378 40.2a2.178 2.178 0 0 0-2.178 2.178v15.244c0 1.203.975 2.178 2.178 2.178h15.244a2.178 2.178 0 0 0 2.178-2.178V42.378a2.178 2.178 0 0 0-2.178-2.178H48.378Zm10.399 14.64c.077.04.163.06.25.06a.545.545 0 0 0 .338-.098.545.545 0 0 0 .218-.544l-.545-3.066 2.243-2.177a.544.544 0 0 0 .136-.545.544.544 0 0 0-.44-.37l-3.104-.452-1.383-2.787a.545.545 0 0 0-.98 0l-1.366 2.793-3.104.451a.545.545 0 0 0-.44.37.544.544 0 0 0 .135.545l2.243 2.178-.544 3.065a.543.543 0 0 0 .79.577L56 53.387l2.777 1.453Z"
			clipRule="evenodd"
		/>
	</chakra.svg>
));

export const Icon6 = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 112 100"
		fill="none"
		{...props}
		ref={ref}
	>
		<path
			fill="#BDBDBD"
			d="M58.777 54.84c.077.04.163.06.25.06a.545.545 0 0 0 .338-.098.545.545 0 0 0 .218-.544l-.545-3.066 2.243-2.177a.544.544 0 0 0 .136-.545.544.544 0 0 0-.44-.37l-3.104-.452-1.383-2.787a.545.545 0 0 0-.98 0l-1.366 2.793-3.104.451a.545.545 0 0 0-.44.37.544.544 0 0 0 .135.545l2.243 2.178-.544 3.065a.543.543 0 0 0 .79.577L56 53.387l2.777 1.453Z"
		/>
		<path
			fill="#BDBDBD"
			fillRule="evenodd"
			d="M46.2 42.378c0-1.203.975-2.178 2.178-2.178h15.244c1.203 0 2.178.975 2.178 2.178v15.244a2.178 2.178 0 0 1-2.178 2.178H48.378a2.178 2.178 0 0 1-2.178-2.178V42.378Zm2.178-1.633h15.244c.903 0 1.634.73 1.634 1.633v15.244c0 .903-.731 1.634-1.634 1.634H48.378a1.633 1.633 0 0 1-1.633-1.634V42.378c0-.902.73-1.633 1.633-1.633Z"
			clipRule="evenodd"
		/>
	</chakra.svg>
));

export const ArrowDownAlt = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		{...props}
		ref={ref}
	>
		<path
			fillRule="evenodd"
			d="M12 4a1 1 0 0 1 1 1v11.586l4.293-4.293a1 1 0 0 1 1.414 1.414l-6 6a1 1 0 0 1-1.414 0l-6-6a1 1 0 1 1 1.414-1.414L11 16.586V5a1 1 0 0 1 1-1Z"
			clipRule="evenodd"
		></path>
	</chakra.svg>
));

export const ArrowRightAlt = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		{...props}
		ref={ref}
	>
		<path
			fillRule="evenodd"
			d="M12.293 5.293a1 1 0 0 1 1.414 0l6 6a1 1 0 0 1 0 1.414l-6 6a1 1 0 0 1-1.414-1.414L16.586 13H5a1 1 0 1 1 0-2h11.586l-4.293-4.293a1 1 0 0 1 0-1.414Z"
			clipRule="evenodd"
		></path>
	</chakra.svg>
));

export const SocialPreset1 = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 112 100"
		{...props}
		ref={ref}
	>
		<path
			fill="#BDBDBD"
			fillRule="evenodd"
			d="M37.333 33.933H11.2v26.134h26.133V33.933Zm-13.066 19.6a6.533 6.533 0 1 0 0-13.066 6.533 6.533 0 0 0 0 13.066Zm44.8-19.6H42.933v26.134h26.134V33.933ZM56 53.533a6.533 6.533 0 1 0 0-13.066 6.533 6.533 0 0 0 0 13.066Zm44.8-19.6H74.667v26.134H100.8V33.933Zm-13.067 19.6a6.533 6.533 0 1 0 0-13.066 6.533 6.533 0 0 0 0 13.066Z"
			clipRule="evenodd"
		/>
	</chakra.svg>
));

export const SocialPreset2 = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 112 100"
		{...props}
		ref={ref}
	>
		<path
			fill="#BDBDBD"
			fillRule="evenodd"
			// eslint-disable-next-line max-len
			d="M37.333 37.667a3.733 3.733 0 0 0-3.733-3.734H14.933a3.733 3.733 0 0 0-3.733 3.734v18.666a3.733 3.733 0 0 0 3.733 3.734H33.6a3.733 3.733 0 0 0 3.733-3.734V37.667ZM24.267 53.533a6.533 6.533 0 1 0 0-13.066 6.533 6.533 0 0 0 0 13.066Zm44.8-15.866a3.733 3.733 0 0 0-3.734-3.734H46.667a3.733 3.733 0 0 0-3.734 3.734v18.666a3.733 3.733 0 0 0 3.734 3.734h18.666a3.733 3.733 0 0 0 3.734-3.734V37.667ZM56 53.533a6.533 6.533 0 1 0 0-13.066 6.533 6.533 0 0 0 0 13.066Zm44.8-15.866a3.733 3.733 0 0 0-3.733-3.734H78.4a3.733 3.733 0 0 0-3.733 3.734v18.666a3.733 3.733 0 0 0 3.733 3.734h18.667a3.733 3.733 0 0 0 3.733-3.734V37.667ZM87.733 53.533a6.533 6.533 0 1 0 0-13.066 6.533 6.533 0 0 0 0 13.066Z"
			clipRule="evenodd"
		/>
	</chakra.svg>
));

export const SocialPreset3 = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 112 100"
		{...props}
		ref={ref}
	>
		<path
			fill="#BDBDBD"
			fillRule="evenodd"
			// eslint-disable-next-line max-len
			d="M24.267 60.067c7.216 0 13.066-5.85 13.066-13.067 0-7.217-5.85-13.067-13.066-13.067C17.05 33.933 11.2 39.783 11.2 47c0 7.217 5.85 13.067 13.067 13.067Zm0-6.534a6.533 6.533 0 1 0 0-13.066 6.533 6.533 0 0 0 0 13.066ZM56 60.067c7.217 0 13.067-5.85 13.067-13.067 0-7.217-5.85-13.067-13.067-13.067-7.217 0-13.067 5.85-13.067 13.067 0 7.217 5.85 13.067 13.067 13.067Zm0-6.534a6.533 6.533 0 1 0 0-13.066 6.533 6.533 0 0 0 0 13.066Zm31.733 6.534c7.217 0 13.067-5.85 13.067-13.067 0-7.217-5.85-13.067-13.067-13.067-7.216 0-13.066 5.85-13.066 13.067 0 7.217 5.85 13.067 13.066 13.067Zm0-6.534a6.533 6.533 0 1 0 0-13.066 6.533 6.533 0 0 0 0 13.066Z"
			clipRule="evenodd"
		/>
	</chakra.svg>
));

export const StackOnIcon1 = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
		ref={ref}
	>
		<path d="M11.977 22a9.936 9.936 0 0 1-3.804-.752 9.93 9.93 0 0 1-3.253-2.17c-.936-.937-1.666-2.031-2.169-3.255S1.995 13.309 2 11.986a9.964 9.964 0 0 1 2.295-6.324l-1.95-1.95a.999.999 0 1 1 1.414-1.414l2.589 2.589a1.786 1.786 0 0 1 .076.076l15.277 15.278a.999.999 0 1 1-1.414 1.414l-1.951-1.951A9.967 9.967 0 0 1 12.009 22h-.032zM5.717 7.084a7.953 7.953 0 0 0-1.091 1.847A7.936 7.936 0 0 0 4 11.994a7.923 7.923 0 0 0 .6 3.067 7.926 7.926 0 0 0 1.734 2.603 7.939 7.939 0 0 0 2.601 1.734c.977.402 1.992.585 3.068.602a7.942 7.942 0 0 0 4.912-1.718L5.717 7.084zm14.323 9.925a1 1 0 0 1-.892-1.449 7.923 7.923 0 0 0 .752-4.853 7.939 7.939 0 0 0-2.234-4.372 7.926 7.926 0 0 0-4.372-2.234 7.943 7.943 0 0 0-4.852.751.999.999 0 1 1-.9-1.786 9.933 9.933 0 0 1 6.068-.94 9.914 9.914 0 0 1 5.469 2.794 9.912 9.912 0 0 1 2.795 5.469 9.92 9.92 0 0 1-.939 6.068 1 1 0 0 1-.895.552z"></path>
	</chakra.svg>
));

export const StackOnIcon2 = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		viewBox="0 0 20 20"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
		ref={ref}
	>
		<path
			fillRule="evenodd"
			d="M2.155 2.988A1.667 1.667 0 0 1 3.333 2.5h13.334a1.666 1.666 0 0 1 1.666 1.667V12.5a1.667 1.667 0 0 1-1.666 1.667h-3.334v1.666h.834a.833.833 0 1 1 0 1.667H5.833a.833.833 0 0 1 0-1.667h.834v-1.666H3.333A1.667 1.667 0 0 1 1.667 12.5V4.167c0-.442.175-.866.488-1.179Zm6.178 11.179v1.666h3.334v-1.666H8.333Zm-5-1.667V4.167h13.334V12.5H3.333Z"
			clipRule="evenodd"
		></path>
	</chakra.svg>
));

export const StackOnIcon3 = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		viewBox="0 0 20 20"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
		ref={ref}
	>
		<path
			fillRule="evenodd"
			d="M3.822 2.155A1.667 1.667 0 0 1 5 1.667h10a1.667 1.667 0 0 1 1.667 1.666v13.334A1.667 1.667 0 0 1 15 18.333H5a1.667 1.667 0 0 1-1.667-1.666V3.333c0-.442.176-.866.489-1.178ZM15 3.333H5v13.334h10V3.333Zm-6.178 9.655a1.667 1.667 0 1 1 2.357 2.358 1.667 1.667 0 0 1-2.357-2.358Z"
			clipRule="evenodd"
		></path>
	</chakra.svg>
));

export const StackOnIcon4 = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
		ref={ref}
	>
		<path
			fillRule="evenodd"
			d="M6.667 3.333a.833.833 0 0 0-.834.834v11.666a.833.833 0 0 0 .834.834h6.666a.833.833 0 0 0 .834-.834V4.167a.833.833 0 0 0-.834-.834h-1.666c0 .46-.373.834-.834.834H9.167a.833.833 0 0 1-.834-.834H6.667ZM4.899 2.4a2.5 2.5 0 0 1 1.768-.732h6.666a2.5 2.5 0 0 1 2.5 2.5v11.666a2.5 2.5 0 0 1-2.5 2.5H6.667a2.5 2.5 0 0 1-2.5-2.5V4.167a2.5 2.5 0 0 1 .732-1.768ZM10 13.333c.46 0 .833.373.833.834v.008a.833.833 0 0 1-1.666 0v-.008c0-.46.373-.834.833-.834Z"
			clipRule="evenodd"
		></path>
	</chakra.svg>
));

export const UpgradeNow = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		viewBox="0 0 81 70"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
		ref={ref}
		fill="none"
	>
		<path
			fill="#4A7EEE"
			d="M61.987 8.04 40.117 0 18.455 7.935c-2.766 1.335-5.19 2.137-5.19 4.773v13.14A50.523 50.523 0 0 0 20.4 51.984C24.441 58.695 30.693 65.606 40.342 70c8.854-2.943 15.464-10.791 19.504-17.506a50.504 50.504 0 0 0 7.136-26.132V14.544c-.016-3.762-1.962-5.598-4.995-6.503Z"
		/>
		<path
			fill="#fff"
			d="M61.987 8.04 40.117 0 18.455 7.935c-2.766 1.335-5.19 2.137-5.19 4.773v13.14A50.523 50.523 0 0 0 20.4 51.984C24.441 58.695 30.693 65.606 40.342 70c8.854-2.943 15.464-10.791 19.504-17.506a50.504 50.504 0 0 0 7.136-26.132V14.544c-.016-3.762-1.962-5.598-4.995-6.503Z"
			opacity=".8"
		/>
		<path
			fill="#4A7EEE"
			d="M53.471 41.281h-4.02V19.455a9.31 9.31 0 0 0-2.735-6.59 9.348 9.348 0 0 0-13.207 0 9.31 9.31 0 0 0-2.735 6.59V41.28h-4.02V19.455a13.31 13.31 0 0 1 3.838-9.562 13.362 13.362 0 0 1 9.52-3.979 13.384 13.384 0 0 1 9.52 3.979 13.332 13.332 0 0 1 3.84 9.562V41.28Z"
		/>
		<path
			fill="#000"
			d="M53.471 41.281h-4.02V19.455a9.31 9.31 0 0 0-2.735-6.59 9.348 9.348 0 0 0-13.207 0 9.31 9.31 0 0 0-2.735 6.59V41.28h-4.02V19.455a13.31 13.31 0 0 1 3.838-9.562 13.362 13.362 0 0 1 9.52-3.979 13.384 13.384 0 0 1 9.52 3.979 13.332 13.332 0 0 1 3.84 9.562V41.28Z"
			opacity=".4"
		/>
		<path
			fill="#4A7EEE"
			d="M56.247 31.568H23.978a1.867 1.867 0 0 0-1.869 1.865v19.323c0 1.03.837 1.865 1.869 1.865h32.269a1.867 1.867 0 0 0 1.868-1.865V33.433c0-1.03-.836-1.865-1.868-1.865Z"
		/>
		<path
			fill="#000"
			d="M43.12 40.094a3 3 0 0 0-1.668-2.69 3.016 3.016 0 0 0-4.15 1.604 2.998 2.998 0 0 0 .585 3.11 3.01 3.01 0 0 0 1.403.865v4.494h1.643v-4.494a3 3 0 0 0 2.188-2.889Z"
			opacity=".5"
		/>
		<path
			fill="#FAFAFA"
			d="M24.029 52.436c-.084 0-.148-3.852-.148-8.586 0-4.735.064-8.586.148-8.586.083 0 .151 3.851.151 8.586 0 4.734-.068 8.586-.151 8.586Zm13.727-8.494s-.141-.045-.354-.199a3.608 3.608 0 0 1-.775-.79 4.205 4.205 0 0 1 1.5-6.316 3.704 3.704 0 0 1 1.06-.357.968.968 0 0 1 .406-.022c0 .058-.57.112-1.351.565a4.179 4.179 0 0 0-2.046 2.691 4.166 4.166 0 0 0 .621 3.32c.282.395.596.765.94 1.108Z"
		/>
		<path
			fill="#4A7EEE"
			d="M1.386 57.838a1.385 1.385 0 1 0 0-2.767 1.385 1.385 0 1 0 0 2.767Zm79.22-45.246a1.38 1.38 0 0 1-.857 1.276 1.39 1.39 0 0 1-1.889-1.01 1.381 1.381 0 0 1 1.36-1.653 1.389 1.389 0 0 1 1.282.856c.07.168.105.349.104.53ZM11.122 60.027a.353.353 0 0 1-.605.248.353.353 0 1 1 .605-.248Zm7.523-38.781a.353.353 0 0 1-.604.25.352.352 0 0 1 .25-.603.354.354 0 0 1 .354.353ZM73.64 40.097a.353.353 0 0 1-.606.249.352.352 0 0 1 .255-.602.351.351 0 0 1 .35.353Zm4.898-13.717a.352.352 0 0 1-.422.349.354.354 0 1 1 .422-.35Z"
		/>
	</chakra.svg>
));

export const CrownIcon = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		{...props}
		ref={ref}
	>
		<rect
			x=".5"
			y=".5"
			width="19"
			height="19"
			rx="2.5"
			fill="#27AE60"
			stroke="#27AE60"
		/>
		<path d="m10 5 3 8H7l3-8Z" fill="#EFEFEF" />
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="m5 7 .714 6h8.572L15 7l-5 4.125L5 7Zm9.286 6.572H5.714V15h8.572v-1.428Z"
			fill="#fff"
		/>
	</chakra.svg>
));

export const Cross = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		{...props}
		ref={ref}
	>
		<path
			fill="#97022E"
			fillRule="evenodd"
			d="M18.71 5.293a1 1 0 0 1 0 1.414l-12 12a1 1 0 0 1-1.414-1.414l12-12a1 1 0 0 1 1.414 0Z"
			clipRule="evenodd"
		/>
		<path
			fill="#97022E"
			fillRule="evenodd"
			d="M5.293 5.293a1 1 0 0 1 1.414 0l12 12a1 1 0 0 1-1.414 1.414l-12-12a1 1 0 0 1 0-1.414Z"
			clipRule="evenodd"
		/>
	</chakra.svg>
));

export const RedCheck = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		{...props}
		ref={ref}
	>
		<path
			fill="#222"
			d="M8.6 19.2c-.3 0-.5-.1-.7-.3l-5.6-5.6c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l4.9 4.9L20.3 5.1c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4L9.3 18.9c-.2.2-.4.3-.7.3Z"
		/>
		<path
			fill="#219653"
			fillRule="evenodd"
			d="M8.6 16.8 20.3 5.1c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4L9.3 18.9c-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3l-5.6-5.6c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l4.9 4.9Z"
			clipRule="evenodd"
		/>
	</chakra.svg>
));
